<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  v-if="privateCompanyMode == 'false' || !privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25 clear-relative"
                >
                  <label>نوع التقرير</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="filterCurrentReportList(CurrentReportList)"
                    v-model="CurrentReport"
                    option-value="id"
                    option-text="name"
                  ></model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('CurrentReport')"
                  />
                </div>

                <div
                  v-else
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25 clear-relative"
                >
                  <label>نوع التقرير</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="filterCurrentReportList(CurrentReportList_true)"
                    v-model="CurrentReport"
                    option-value="id"
                    option-text="name"
                  ></model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('CurrentReport')"
                  />
                </div>

                <div
                  v-if="
                    CurrentReport == '5' ||
                      CurrentReport == '20' ||
                      CurrentReport == '10' ||
                      CurrentReport == '12' ||
                      CurrentReport == '11' ||
                      CurrentReport == '16'
                  "
                  class="md-layout-item md-size-30 ml-15 mt-25 clear-relative"
                >
                  <label>الوحدة التنظيمية</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="departments"
                    v-model="DepartmentIdTimesheet"
                    option-value="id"
                    option-text="name"
                  >
                  </model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('DepartmentIdTimesheet')"
                  />
                </div>

                <div
                  v-if="
                    CurrentReport == '5' ||
                      CurrentReport == '21' ||
                      CurrentReport == '20' ||
                      CurrentReport == '23' ||
                      CurrentReport == '9' ||
                      CurrentReport == '11' ||
                      CurrentReport == '12' ||
                      CurrentReport == '16' ||
                      CurrentReport == '17' ||
                      CurrentReport == '18' ||
                      CurrentReport == '19' ||
                      CurrentReport == '25' ||
                      CurrentReport == '26'
                  "
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>الموظف</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="employees"
                    v-model="EmployeeIdTimesheet"
                    option-value="key"
                    option-text="value"
                  >
                  </model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('EmployeeIdTimesheet')"
                  />
                </div>
                <div
                  v-if="CurrentReport == '9'"
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>الموظف المنتهي خدمته</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="endedServiceEmployeesList"
                    v-model="endedServiceEmployeeId"
                    option-value="key"
                    option-text="value"
                  >
                  </model-list-select>
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('EmployeeIdTimesheet')"
                  />
                </div>

                <div
                  v-if="CurrentReport == '22'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="endEmployees"
                    v-model="endEmployeesId"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  v-if="CurrentReport == '24'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="AllEmployees"
                    v-model="EmployeeIdTimesheet"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  v-if="CurrentReport == '22'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الموظف</label>
                    <md-input type="number" v-model="JobNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '22'"
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <md-field>
                    <label>نوع انتهاء الخدمة</label>
                    <md-select v-model="typeEndService">
                      <md-option value="1">استقالة</md-option>
                      <md-option value="2">فصل من الخدمة</md-option>
                      <md-option
                        v-if="privateCompanyMode === 'false'"
                        value="3"
                      >
                        تقاعد لبلوغ السن القانونية
                      </md-option>
                      <md-option v-if="privateCompanyMode === 'false'" value="4"
                        >تقاعد اختياري</md-option
                      >
                      <md-option value="5">وفاة</md-option>
                      <md-option v-if="privateCompanyMode === 'false'" value="6"
                        >انهاء الندب</md-option
                      >
                      <md-option v-if="privateCompanyMode === 'false'" value="7"
                        >نقل</md-option
                      >
                      <md-option value="8">استقالة اعتبارية</md-option>
                      <md-option value="9">فسخ عقد</md-option>
                      <md-option
                        v-if="privateCompanyMode === 'false'"
                        value="10"
                        >انتهاء التعاون</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '5'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="vacationTypes"
                    v-model="vacationId"
                    option-value="key"
                    option-text="value"
                    placeholder="نوع الإجازة"
                  >
                  </model-list-select>
                </div>

                <div
                  v-if="
                    CurrentReport == '5' ||
                      CurrentReport == '13' ||
                      CurrentReport == '23'
                  "
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>السنة</label>
                    <md-input type="number" v-model="vacationYear"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="
                    CurrentReport == '8' ||
                      CurrentReport == '9' ||
                      CurrentReport == '11' ||
                      CurrentReport == '22' ||
                      CurrentReport == '16' ||
                      CurrentReport == '25' ||
                      CurrentReport == '26'
                  "
                  class="md-layout-item md-size-30 mt-50"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="DateFrom">
                    <label class="mr-28">من تاريخ</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="
                    CurrentReport == '8' ||
                      CurrentReport == '9' ||
                      CurrentReport == '11' ||
                      CurrentReport == '22' ||
                      CurrentReport == '16' ||
                      CurrentReport == '25' ||
                      CurrentReport == '26'
                  "
                  class="md-layout-item md-size-30 mtb-25"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="DateTo">
                    <label class="mr-28">الى تاريخ</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentReport == '26'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>الحالة</label>
                    <md-select v-model="timeSheetDurationStatus">
                      <md-option value="1">معتمد</md-option>
                      <md-option value="2">غير معتمد</md-option>
                    </md-select>
                  </md-field>
                </div>

                <!-- تقرير حالة حضور الموظف - وضع البحث + اختيار الموظف (وضع 1) -->
                <div
                  class="md-layout"
                  style="align-items: flex-start"
                  v-if="CurrentReport == '27' && attendanceSearchMode == 1"
                >
                  <div class="md-layout-item md-size-50 mt-50 ml-15">
                    <md-field>
                      <label>نوع التقرير</label>
                      <md-select v-model="attendanceSearchMode">
                        <md-option :value="1">حسب الموظف</md-option>
                        <md-option :value="2">حسب المكان</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-40 mt-25 ml-15 clear-relative"
                  >
                    <label>الموظف</label>
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeIdTimesheet"
                      option-value="key"
                      option-text="value"
                      placeholder="اختر الموظف"
                    />
                    <ClearButton
                      class="absolute-clear-button"
                      @click.native="clearfield('EmployeeIdTimesheet')"
                    />
                  </div>
                </div>

                <!-- تقرير حالة حضور الموظف - وضع البحث + اختيار المكان (وضع 2) -->
                <div
                  class="md-layout"
                  style="align-items: flex-start"
                  v-if="CurrentReport == '27' && attendanceSearchMode == 2"
                >
                  <div class="md-layout-item md-size-50 mt-50 ml-15">
                    <md-field>
                      <label>نوع التقرير</label>
                      <md-select v-model="attendanceSearchMode">
                        <md-option :value="1">حسب الموظف</md-option>
                        <md-option :value="2">حسب المكان</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div
                    class="md-layout-item md-size-40 mt-25 ml-15 clear-relative"
                  >
                    <label>مكان العمل</label>
                    <model-list-select
                      class="input-must-rtl"
                      :list="workPlacesList"
                      v-model="workplaceId"
                      option-value="id"
                      option-text="name"
                      placeholder="اختر مكان العمل"
                    />
                    <ClearButton
                      class="absolute-clear-button"
                      @click.native="clearfield('workplaceId')"
                    />
                  </div>
                </div>

                <md-table
                  style="margin-right: 30px !important"
                  v-if="CurrentReport == '11'"
                  class="paginated-table custome-paginated-table table-striped table-hover mt-25 ml-15 font-size-style"
                >
                  <md-table-row class="font-size-style-row" slot="md-table-row">
                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="IsWeekendDaysIncluded">
                          إظهار أعمدة عطلة الأسبوع
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell></md-table-cell>
                  </md-table-row>
                </md-table>

                <div
                  v-if="CurrentReport == '12'"
                  class="md-layout-item md-size-30 ml-15 mt-50"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="dateF">
                    <label class="mr-28">تاريخ الطباعة</label>
                  </md-datepicker>
                </div>

                <div
                  v-if="CurrentReport == '12'"
                  class="md-layout-item md-size-30 mt-25 ml-15 clear-relative"
                >
                  <label>مكان العمل</label>
                  <model-list-select
                    class="input-must-rtl"
                    :list="workPlacesList"
                    v-model="workplaceId"
                    option-value="id"
                    option-text="name"
                    placeholder="اختر مكان العمل"
                  />
                  <ClearButton
                    class="absolute-clear-button"
                    @click.native="clearfield('workplaceId')"
                  />
                </div>

                <div
                  v-if="CurrentReport == '10'"
                  class="md-layout-item md-layout-item-time md-size-30 ml-50"
                  style="position: relative"
                >
                  <h4 class="monthly-picker-head" :class="{ active: dateF }">
                    تاريخ الطباعة
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="dateF"
                  />
                </div>

                <div
                  v-if="CurrentReport == '3'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="employees"
                    v-model="FullName_report"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  v-if="CurrentReport == '16'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <ClearButton @click.native="clearfield('TypeT')" />

                    <label>النوع </label>
                    <md-select v-model="TypeT">
                      <md-option value="0">الكل</md-option>
                      <md-option value="1">حضور متأخر</md-option>
                      <md-option value="2">خروج مبكر</md-option>
                      <md-option value="3">غياب</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '17' ||
                      CurrentReport == '18' ||
                      CurrentReport == '21' ||
                      CurrentReport == '4' ||
                      CurrentReport == '13' ||
                      CurrentReport == '14' ||
                      CurrentReport == '15'
                  "
                  class="md-layout-item md-size-30 ml-15 mt-25"
                >
                  <md-field>
                    <button
                      @click="clear_DepartmentId"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                    <model-list-select
                      class="input-must-rtl"
                      :list="departments"
                      v-model="DepartmentId"
                      option-value="id"
                      option-text="name"
                      placeholder="يتبع لـ"
                    ></model-list-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '14'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم القرار</label>
                    <md-input v-model="LetterNumber"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '14'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>سبب الإجازة</label>
                    <md-input type="number" v-model="Reason"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '15'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>نوع الندب</label>
                    <md-select v-model="DelegationState">
                      <md-option value="1"> خارج المؤسسة</md-option>
                      <md-option value="2">داخل المؤسسة</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- 
                <div
                  v-if="CurrentReport == '21'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>الوضع الوظيفي</label>
                    <md-select v-model="CurrentJobStatus">
                      <md-option value="1">مستمر</md-option>
                      <md-option value="2">منتدب إلى جهة </md-option>
                      <md-option value="3">إيقاف مؤقت</md-option>
                      <md-option value="4">متفرغ</md-option>
                      <md-option value="5">مكلف</md-option>
                      <md-option value="6">تدريب</md-option>
                      <md-option value="7">إجازة من غير مرتب</md-option>
                    </md-select>
                  </md-field>
                </div> -->

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '17' ||
                      CurrentReport == '21' ||
                      CurrentReport == '18'
                  "
                  class="md-layout-item md-size-30 ml-15 mt-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="jobTitles"
                    v-model="JobTitleID_load"
                    option-value="id"
                    option-text="name"
                    placeholder="الصفة الوظيفية"
                  ></model-list-select>
                </div>

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '17' ||
                      // CurrentReport == '21' ||
                      CurrentReport == '18'
                  "
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>التصنيف الوظيفي</label>
                    <md-select v-model="JobtitelClassification">
                      <md-option value="0">موظف</md-option>
                      <md-option value="1">مدير إدارة</md-option>
                      <md-option value="2">رئيس قسم</md-option>
                      <md-option value="3">رئيس وحدة</md-option>
                      <md-option value="4">مدير عام</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '12'"
                  class="md-layout-item md-size-30 md-small-size-100 mtb-25"
                >
                  <form-time
                    v-model="FromTime"
                    class="form-date"
                    placeholder="الفلترة بوقت الحضور"
                    label
                  />
                </div>

                <div
                  v-if="CurrentReport == '12'"
                  class="md-layout-item md-size-30 md-small-size-100 mtb-25"
                >
                  <form-time
                    v-model="ToTime"
                    class="form-date"
                    placeholder="الفلترة بوقت الانصراف"
                    label
                  />
                </div>

                <div
                  style="padding-left: 30px !important"
                  v-if="
                    CurrentReport == '12' ||
                      CurrentReport == '11' ||
                      CurrentReport == '10' ||
                      CurrentReport == '16'
                  "
                  class="md-layout-item md-size-95 ml-15 mt-25"
                >
                  <md-field>
                    <label>التصنيفات</label>

                    <md-select
                      multiple
                      v-model="FilterDeparmentClassificationsIds"
                    >
                      <md-option
                        v-for="(item, i) in departmentClassification"
                        :key="i"
                        :value="item.id"
                        >{{ item.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '17' ||
                      CurrentReport == '21' ||
                      CurrentReport == '18'
                  "
                  class="md-layout-item md-size-30 ml-15 mt-25"
                >
                  <md-field>
                    <button
                      @click="clear_SectionId"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                    <label>القسم</label>
                    <md-select v-model="SectionId">
                      <md-option
                        v-for="department in departmentsLoad"
                        v-bind:key="department.id"
                        :value="department.id"
                        >{{ department.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <!-- <div
                      v-if="CurrentReport == '1'"
                      class="md-layout-item md-size-30 mt-25 ml-15"
                    >
                      <md-field>
                        <label>الرقم الوطني</label>
                        <md-input v-model="NationalNumber"></md-input>
                      </md-field>
                    </div> -->

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '8' ||
                      CurrentReport == '17' ||
                      CurrentReport == '21' ||
                      CurrentReport == '18'
                  "
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <button
                      @click="clear_DepartmentClassificationsId"
                      type="button"
                      class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                      tabindex="-1"
                    >
                      <div class="md-ripple">
                        <div class="md-button-content">
                          <i
                            class="md-icon md-icon-font md-icon-image md-theme-default"
                            ><svg
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                              ></path>
                              <path d="M0 0h24v24H0z" fill="none"></path></svg
                          ></i>
                        </div>
                      </div>
                    </button>
                    <label>تصنيف الفروع</label>
                    <md-select v-model="DepartmentClassificationsId">
                      <md-option
                        v-for="departmentClassification in departmentClassification"
                        v-bind:key="departmentClassification.id"
                        :value="departmentClassification.id"
                        >{{ departmentClassification.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="
                    CurrentReport == '1' ||
                      CurrentReport == '17' ||
                      // CurrentReport == '21' ||
                      CurrentReport == '18'
                  "
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>نوع التوظيف</label>
                    <md-select v-model="JobType">
                      <md-option value="1">تعيين</md-option>
                      <md-option value="2">عقد</md-option>
                      <md-option value="3">ندب</md-option>
                      <md-option value="4">إعارة</md-option>
                      <md-option value="5">عقد مصنف</md-option>
                      <md-option value="6">عقد متعاون</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '21'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>عنوان التقرير</label>
                    <md-input v-model="ReportAddress"></md-input>
                  </md-field>
                </div>

                <md-checkbox
                  v-if="CurrentReport == '21'"
                  v-model="IsEndedService"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  تضمين الموظفين المنتهي خدمتهم
                </md-checkbox>

                <md-checkbox
                  v-if="CurrentReport == '21'"
                  v-model="OrderByJobNumber"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  ترتيب حسب رقم الموظف
                </md-checkbox>

                <div
                  v-if="CurrentReport == '21' && IsEndedService"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>سبب انتهاء الخدمة</label>
                    <md-select v-model="TypeOfEndService">
                      <md-option value="1">استقال</md-option>
                      <md-option value="2">إقالة</md-option>
                      <md-option value="3">تقاعد</md-option>
                      <md-option value="4">تقاعد اختياري</md-option>
                      <md-option value="5">وفاة</md-option>
                      <md-option value="6">انهاء ندب</md-option>
                      <md-option value="7">نقل</md-option>
                      <md-option value="7">استقالة اعتبارية</md-option>
                      <md-option value="7">فسخ عقد</md-option>
                      <md-option value="7">انتهاء تعاون</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="mt-25 ml-15"
                  style="width: 100%"
                  v-if="CurrentReport == '21'"
                >
                  <md-field>
                    <label>اسم العامود</label>
                    <v-select
                      style="width: 100%"
                      dir="rtl"
                      multiple
                      :reduce="item => item"
                      label="arabicName"
                      v-model="filter"
                      :options="
                        col_pdf.filter(item =>
                          privateCompanyStyle
                            ? item.privateCompanyMode === privateCompanyStyle
                            : item
                        )
                      "
                      placeholder="اسم العامود"
                    ></v-select>
                  </md-field>
                </div>

                <!-- التقرير الشامل للموظف -->
                <ComprehensiveEmployeeReport
                  v-if="CurrentReport == '21'"
                  @search="Search"
                  @empty="empty"
                  @excel="generateExcelFileForReport21"
                  @pdf="generatePdfFileForReport21"
                />

                <Lodding
                  v-if="lodding_bool && CurrentReport == '21'"
                  color="green"
                  :scale="0.4"
                />

                <md-table
                  v-if="CurrentReport == '1'"
                  class="paginated-table custome-paginated-table table-striped table-hover mt-25 font-size-style"
                >
                  <md-table-row class="font-size-style-row" slot="md-table-row">
                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_jobNumber">
                          رقم الموظف
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_nat">
                          رقم الوطني
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_sci">
                          المؤهل العلمي
                        </md-checkbox>
                      </p>
                    </md-table-cell>
                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_d"> الادارة </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_jop">
                          الصفة الوظيفية
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_current">
                          الحالة الوظيفية
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_Grade"> الدرجة </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="col_Bonus"> العلاوة </md-checkbox>
                      </p>
                    </md-table-cell>
                    <md-table-cell></md-table-cell>
                  </md-table-row>
                </md-table>

                <md-table
                  style="margin-right: 30px !important"
                  v-if="CurrentReport == '3'"
                  class="paginated-table custome-paginated-table table-striped table-hover mt-25 ml-15 font-size-style"
                >
                  <md-table-row class="font-size-style-row" slot="md-table-row">
                    <md-table-cell>
                      <p>
                        <md-checkbox v-model="personalPicture">
                          إظهار الصورة الشخصية في التقرير
                        </md-checkbox>
                      </p>
                    </md-table-cell>

                    <md-table-cell></md-table-cell>
                  </md-table-row>
                </md-table>

                <div
                  v-if="CurrentReport == '4'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>رصيد الأيام</label>
                    <md-input v-model="Days_R"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '6' || CurrentReport == '7'"
                  class="md-layout-item md-layout-item-time md-size-30 ml-15 mt-25"
                  style="position: relative"
                >
                  <h4
                    class="monthly-picker-head"
                    :class="{ active: monthDate_R }"
                  >
                    تاريخ الشهر
                  </h4>
                  <vue-monthly-picker
                    class="monthly-picker"
                    alignment="right"
                    v-model="monthDate_R"
                  />
                </div>
                <div
                  v-if="CurrentReport == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <label>الدرجة</label>
                    <md-select v-model="Grade">
                      <md-option value="1">الدرجة الاولى</md-option>
                      <md-option value="2">الدرجة التانية</md-option>
                      <md-option value="3">الدرجة الثالتة</md-option>
                      <md-option value="4">الدرجة الرابعة</md-option>
                      <md-option value="5">الدرجة الخامسة</md-option>
                      <md-option value="6">الدرجة السادسة</md-option>
                      <md-option value="7">الدرجة السابعة</md-option>
                      <md-option value="8">الدرجة الثامنة</md-option>
                      <md-option value="9">الدرجة التاسعة</md-option>
                      <md-option value="10">الدرجة العاشرة</md-option>
                      <md-option value="11">الدرجة الحادية عشر</md-option>
                      <md-option value="12">الدرجة التانية عشر</md-option>
                      <md-option value="13">الدرجة الثالتة عشر</md-option>
                      <md-option value="14">الدرجة الرابعة عشر</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport == '6'"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field>
                    <!-- <label>نوع التوظيف</label> -->
                    <md-select v-model="AboveGrade"
                      >طباعة
                      <md-option :value="true">مايعلوها</md-option>
                      <md-option :value="false">مادونها</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  v-if="CurrentReport != '21'"
                  class="md-layout-item md-size-100 mt-25 mtb-25"
                  style="text-align: center"
                >
                  <md-button
                    v-if="
                      CurrentReport != '25' &&
                        CurrentReport != '26' &&
                        CurrentReport != '27'
                    "
                    @click="Search"
                    class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button
                    v-if="CurrentReport == '25'"
                    @click="searchDelayAbsenceDeduction"
                    class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button
                    v-if="CurrentReport == '26'"
                    @click="searchTimesheetStatus"
                    class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button
                    v-if="CurrentReport == '27'"
                    @click="searchAttendanceStatus"
                    class="md-success btn_nanosoft"
                    >بحث</md-button
                  >
                  <md-button
                    v-if="CurrentReport == '21'"
                    class="md-success btn_nanosoft"
                    @click="empty"
                  >
                    افراغ
                  </md-button>
                  <md-button
                    v-if="
                      CurrentReport != '8' &&
                        CurrentReport != '18' &&
                        CurrentReport != '9' &&
                        CurrentReport != '16' &&
                        CurrentReport != '25' &&
                        CurrentReport != '26' &&
                        CurrentReport != '27'
                    "
                    @click="generateReport"
                    class="md-info btn_nanosoft"
                  >
                    طباعة PDF
                  </md-button>

                  <md-button
                    v-if="
                      CurrentReport == '18' ||
                        CurrentReport == '17' ||
                        CurrentReport == '12' ||
                        CurrentReport == '21' ||
                        CurrentReport == '17' ||
                        CurrentReport == '19' ||
                        CurrentReport == '11'
                    "
                    @click="generateReport_ex"
                    class="md-info btn_nanosoft"
                  >
                    طباعة Excel
                  </md-button>
                  <template v-if="CurrentReport == '16'">
                    <md-button
                      class="md-info btn_nanosoft"
                      @click="printDelayCheckinEarlyCheckoutReport(0)"
                    >
                      طباعة PDF
                    </md-button>
                    <md-button
                      class="md-info btn_nanosoft"
                      @click="printDelayCheckinEarlyCheckoutReport(1)"
                    >
                      طباعة EXCEL
                    </md-button>
                  </template>

                  <md-button
                    v-if="CurrentReport == '9'"
                    class="md-info btn_nanosoft"
                    @click="getEmployeeInOut(0)"
                  >
                    طباعة PDF
                  </md-button>
                  <md-button
                    v-if="CurrentReport == '9'"
                    class="md-info btn_nanosoft"
                    @click="getEmployeeInOut(1)"
                  >
                    طباعة EXCEL
                  </md-button>

                  <md-button
                    v-if="CurrentReport == '25'"
                    class="md-info btn_nanosoft"
                    @click="getDelayAbsenceDeduction(0)"
                  >
                    طباعة PDF
                  </md-button>
                  <md-button
                    v-if="CurrentReport == '25'"
                    class="md-info btn_nanosoft"
                    @click="getDelayAbsenceDeduction(1)"
                  >
                    طباعة EXCEL
                  </md-button>

                  <md-button
                    v-if="CurrentReport == '26'"
                    class="md-info btn_nanosoft"
                    @click="exportTimesheetStatus()"
                  >
                    طباعة PDF
                  </md-button>

                  <md-button
                    v-if="CurrentReport == '27'"
                    class="md-info btn_nanosoft"
                    @click="exportAttendanceStatus('pdf')"
                  >
                    طباعة PDF
                  </md-button>
                  <md-button
                    v-if="CurrentReport == '27'"
                    class="md-info btn_nanosoft"
                    @click="exportAttendanceStatus('excel')"
                  >
                    طباعة EXCEL
                  </md-button>

                  <md-button
                    v-if="CurrentReport == '8'"
                    class="md-info btn_nanosoft"
                    @click="downloadWord"
                  >
                    طباعة Word
                  </md-button>
                  <StaffListsReportExcel
                    :name="companyName"
                    :desc="companyDesc"
                    :month="convert(monthDate_R)"
                    :departmentId="DepartmentId"
                    :departmentClassificationsId="DepartmentClassificationsId"
                    :jobType="JobType"
                    v-if="CurrentReport == 1"
                  />

                  <EmployeeCardReportExcel
                    :name="companyName"
                    :desc="companyDesc"
                    :month="convert(monthDate_R)"
                    :fullName="FullName_report"
                    v-if="CurrentReport == 3"
                  />

                  <PromotionsReportExcel
                    :name="companyName"
                    :desc="companyDesc"
                    :month="convert(monthDate_R)"
                    :grade="Grade"
                    :gradeString="Grade_string"
                    :aboveGrade="AboveGrade"
                    :aboveGradeString="AboveGrade_string"
                    :date="convert(new Date())"
                    v-if="CurrentReport == 6"
                  />
                  <BonusesReportExcel
                    :name="companyName"
                    :desc="companyDesc"
                    :month="convert(monthDate_R)"
                    v-if="CurrentReport == 7"
                  />

                  <Lodding v-if="lodding_bool" color="green" :scale="0.4" />
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div class="md-layout-item">
      <div class="md-layout-item md-size-20">
        <div v-if="pdfLoadingActive" class="overlay-pdf">
          <h3 class="head-loading-pdf">جارى تحميل الملف</h3>
          <atom-spinner
            class="pdfLoading"
            :animation-duration="1000"
            :size="160"
            color="#4caf50"
          />
          <!-- <div style="width: 50%">
            <step-progress :steps="mySteps" :current-step="currentStep" :line-thickness="50" :active-color="'#4caf50'"
              :passive-color="'#999999'"></step-progress>
          </div> -->
        </div>
      </div>
      <md-card>
        <!-- ////////////  View  /////////// -->
        <CheckoutReport
          :TypeT="TypeT"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 16"
        />

        <GetEmployeesAlllnfo
          :enName="enName"
          :arabicName="arabicName"
          :TypeT="TypeT"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 21"
        />

        <FunctionalData
          :TypeT="TypeT"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 17"
        />

        <WorkFreeEmployees
          :TypeT="TypeT"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 20"
        />

        <EndService
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 22"
        />
        <EmployeeEfficiencies
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 23"
        />

        <PersonalData
          :TypeT="TypeT"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 18"
        />

        <DailyReport
          :dateF="dateF"
          :name="companyName"
          :desc="companyDesc"
          :DepartmentId="DepartmentId"
          :countE="countE"
          :data="items"
          :pathLogo="pathLogo"
          v-if="CurrentReport == 12"
        />

        <ViewTimesheetD
          :items="items"
          :alldata="allData"
          :date="DateFrom"
          :DateTo="DateTo"
          :pathLogo="pathLogo"
          v-if="CurrentReport == 11"
        />

        <ViewTimesheet
          :items="items"
          :alldata="allData"
          :date="dateF"
          :pathLogo="pathLogo"
          v-if="CurrentReport == 10"
        />

        <TimesheetEmployee
          :items="items"
          :alldata="allData"
          :date="dateF"
          :pathLogo="pathLogo"
          :options="{
            DateTo: DateTo,
            DateFrom: DateFrom
          }"
          v-if="CurrentReport == 9"
        />

        <ViewStaffLists
          :name="companyName"
          :desc="companyDesc"
          :data="pdfData"
          v-if="CurrentReport == 1"
        />

        <nonPaidVacation
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 14"
        />
        <Retirees
          :vacationYear="vacationYear"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 13"
        />
        <DelegatedEmployees
          :DelegationState="DelegationState"
          :data="items"
          :allData="allData"
          v-if="CurrentReport == 15"
        />

        <ViewPreparation
          :allData="socialSolidarities"
          :shortName="shortName"
          :fullName="fullName"
          :AboveGrade="AboveGrade_string"
          :Grade="Grade_string"
          :total="total_Head_Count"
          :date="convert(new Date())"
          v-if="CurrentReport == 2"
        />

        <ViewEmployeeCard
          :shortName="shortName"
          :fullName="fullName"
          :allData="socialSolidarities"
          :Date="convert(new Date())"
          v-if="CurrentReport == 3"
        />

        <ViewVacationsBalance
          :allData="socialSolidarities"
          :shortName="shortName"
          :fullName="fullName"
          :Days="Days_R"
          :monthDate="convert_rtl(new Date())"
          :countEmployee="countEmployee"
          v-if="CurrentReport == 4"
        />

        <vacationsReport
          :name="companyName"
          :vacationName="vacationName"
          :vacationYear="vacationYear"
          :desc="companyDesc"
          :data="items"
          v-if="CurrentReport == 5"
        />

        <ViewCareerPromotion
          :allData="socialSolidarities"
          :shortName="shortName"
          :fullName="fullName"
          :AboveGrade="AboveGrade_string"
          :Grade="Grade_string"
          :monthDate="convert_Month(monthDate_R)"
          v-if="CurrentReport == 6"
        />

        <ViewMonthlyVariables
          v-if="CurrentReport == '8'"
          :allData="monthlyVariables"
          :DateFrom="DateFrom"
          :DateTo="DateTo"
        />

        <MonthlyVariables
          v-if="CurrentReport == '9'"
          :allData="monthlyVariables"
          :monthDate="monthDate_R"
        />

        <!-- جدول تقرير خصم التأخير والغياب -->
        <div v-if="CurrentReport == '25'" class="md-layout">
          <!-- ملخص التقرير -->
          <div
            v-if="delayAbsenceDeductionData.length > 0"
            class="md-layout-item md-size-100 mb-3"
          >
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-card class="md-card-stats" style="min-height: auto">
                  <md-card-content style="padding: 10px 15px">
                    <div
                      class="statistics"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <h4 class="info-title" style="margin: 0">
                        إجمالي قيمة الخصم
                      </h4>
                      <h3 class="title text-success" style="margin: 0">
                        {{ totalDiscountValue }}
                      </h3>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-card class="md-card-stats" style="min-height: auto">
                  <md-card-content style="padding: 10px 15px">
                    <div
                      class="statistics"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <h4 class="info-title" style="margin: 0">
                        عدد ساعات الحضور
                      </h4>
                      <h3 class="title text-info" style="margin: 0">
                        {{ totalAttendanceTime }}
                      </h3>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <md-card class="md-card-stats" style="min-height: auto">
                  <md-card-content style="padding: 10px 15px">
                    <div
                      class="statistics"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <h4 class="info-title" style="margin: 0">
                        عدد ساعات التأخير
                      </h4>
                      <h3 class="title text-warning" style="margin: 0">
                        {{ totalDelayValues }}
                      </h3>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">تقرير خصم التأخير والغياب</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <table
                  v-if="delayAbsenceDeductionData.length > 0"
                  class="table table-striped table-hover"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th style="padding: 12px 16px">التاريخ</th>
                      <th style="padding: 12px 16px">اليوم</th>
                      <th style="padding: 12px 16px">وقت الحضور</th>
                      <th style="padding: 12px 16px">وقت الانصراف</th>
                      <th style="padding: 12px 16px">قيمة التأخير</th>
                      <th style="padding: 12px 16px">قيمة الخصم</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in delayAbsenceDeductionData"
                      :key="index"
                    >
                      <td style="padding: 12px 16px">{{ item.date }}</td>
                      <td style="padding: 12px 16px">{{ item.day }}</td>
                      <td style="padding: 12px 16px">{{ item.timeIn }}</td>
                      <td style="padding: 12px 16px">{{ item.timeOut }}</td>
                      <td style="padding: 12px 16px">{{ item.delayValue }}</td>
                      <td style="padding: 12px 16px">
                        {{ item.discountValue }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  v-else-if="delayAbsenceDeductionData.length === 0"
                  class="text-center mt-25"
                >
                  <p>لا توجد بيانات للعرض</p>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>

        <!-- جدول تقرير حالة جدول الحضور والانصراف -->
        <ViewTimesheetStatus
          :data="timesheetStatusData"
          v-if="CurrentReport == '26'"
        />

        <!-- جدول تقرير حالة حضور الموظف (27) -->
        <div v-if="CurrentReport == '27'">
          <!-- وضع 1: عرض حسب الموظف -->
          <div
            v-if="attendanceSearchMode == 1 && attendanceStatusData.length > 0"
            class="md-layout mt-25"
          >
            <div class="md-layout-item md-size-100">
              <md-card>
                <md-card-header
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">
                      حالة حضور الموظف: {{ attendanceEmployeeName }}
                    </h4>
                  </div>
                </md-card-header>
                <md-card-content>
                  <md-table
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row>
                      <!-- <md-table-cell>حالة الموظف</md-table-cell> -->
                      <md-table-cell>آخر حالة حضور</md-table-cell>
                      <md-table-cell>آخر مكان عمل</md-table-cell>
                      <!-- <md-table-cell>حالة المزامنة</md-table-cell> -->
                      <!-- <md-table-cell>آخر تحديث (ثواني : دقائق)</md-table-cell> -->
                    </md-table-row>
                    <md-table-row
                      v-for="(item, i) in attendanceStatusData"
                      :key="i"
                    >
                      <!-- <md-table-cell>
                        <span
                          class="connection-pill"
                          :class="
                            isOnline(item.connectionStatus)
                              ? 'is-online'
                              : 'is-offline'
                          "
                        >
                          <span class="connection-dot"></span>
                          {{ item.connectionStatus }}
                        </span>
                      </md-table-cell> -->
                      <md-table-cell>{{ item.employeeStatus }}</md-table-cell>
                      <md-table-cell>{{ item.workPace }}</md-table-cell>
                      <!-- <md-table-cell>
                        <span
                          class="connection-pill sync-pill"
                          :class="
                            item.isMobileSynced ? 'is-synced' : 'is-not-synced'
                          "
                        >
                          <span class="connection-dot"></span>
                          {{ syncLabel(item.isMobileSynced) }}
                        </span>
                      </md-table-cell> -->
                      <!-- <md-table-cell>{{ item.lastSync }}</md-table-cell> -->
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <!-- وضع 2: عرض حسب المكان -->
          <div
            v-if="attendanceSearchMode == 2 && attendanceStatusData.length > 0"
            class="md-layout mt-25"
          >
            <div class="md-layout-item md-size-100">
              <md-card>
                <md-card-header
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">
                      حالة الحضور في: {{ attendanceWorkPlaceName }}
                    </h4>
                  </div>
                </md-card-header>
                <md-card-content>
                  <md-table
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row>
                      <md-table-cell>ر.م</md-table-cell>
                      <md-table-cell>الموظف</md-table-cell>
                      <!-- <md-table-cell>حالة الموظف</md-table-cell> -->
                      <md-table-cell>آخر حالة حضور</md-table-cell>
                      <!-- <md-table-cell>حالة المزامنة</md-table-cell> -->
                      <!-- <md-table-cell>آخر تحديث (ثواني : دقائق)</md-table-cell> -->
                    </md-table-row>
                    <md-table-row
                      v-for="(item, i) in attendanceStatusData"
                      :key="i"
                    >
                      <md-table-cell>{{ i + 1 }}</md-table-cell>
                      <md-table-cell>{{ item.employeeName }}</md-table-cell>
                      <!-- <md-table-cell>
                        <span
                          class="connection-pill"
                          :class="
                            isOnline(item.connectionStatus)
                              ? 'is-online'
                              : 'is-offline'
                          "
                        >
                          <span class="connection-dot"></span>
                          {{ item.connectionStatus }}
                        </span>
                      </md-table-cell> -->
                      <md-table-cell>{{ item.employeeStatus }}</md-table-cell>
                      <!-- <md-table-cell>
                        <span
                          class="connection-pill sync-pill"
                          :class="
                            item.isMobileSynced ? 'is-synced' : 'is-not-synced'
                          "
                        >
                          <span class="connection-dot"></span>
                          {{ syncLabel(item.isMobileSynced) }}
                        </span>
                      </md-table-cell> -->
                      <!-- <md-table-cell>{{ item.lastSync }}</md-table-cell> -->
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>

          <div
            v-if="attendanceStatusData.length === 0"
            class="text-center mt-25"
          >
            <p>لا توجد بيانات للعرض</p>
          </div>
        </div>

        <div v-if="CurrentReport == '19'">
          <div style="direction: initial" class="md-layout mt-25">
            <div class="md-layout-item md-size-100 mt-25">
              <h3 class="text-center">تقرير تسلسل حركة ترقيات الموظف</h3>
            </div>

            <div style="text-align: end" class="md-layout-item md-size-30">
              <h3 class="text-right">{{ name.fullName }}</h3>
              <h4 class="text-right">{{ name.shortName }}</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <md-card>
                <md-card-header
                  style="margin-bottom: 30px"
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">تقرير تسلسل حركة ترقيات الموظف</h4>
                  </div>
                </md-card-header>
                <div style="margin: 10px 20px 10px 10px" class="md-layout">
                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>اسم الموظف</label>
                      <md-input
                        v-model="EmployeeName"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>الرقم الوظيفي</label>
                      <md-input
                        v-model="JobNumber"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>الادارة</label>
                      <md-input
                        v-model="Department"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> الدرجة الحالية</label>
                      <md-input
                        v-model="CurrentGrade"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> بتاريخ</label>
                      <md-input
                        v-model="CurrentGradeDate"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> بموجب قرار السيد </label>
                      <md-input
                        v-model="CurrentGradeDecisionSource"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> رقم</label>
                      <md-input
                        v-model="CurrentGradeDecisionNumber"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> الدرجة عند التعيين</label>
                      <md-input
                        v-model="GradeAppointment"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> بتاريخ</label>
                      <md-input
                        v-model="GradeAppointmentDate"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> بموجب قرار السيد </label>
                      <md-input
                        v-model="GradeAppointmentDecisionSource"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-size-20 mt-25 ml-15">
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label> رقم</label>
                      <md-input
                        v-model="GradeAppointmentDecisionNumber"
                        readonly="readonly"
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="items"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="report paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <!-- <md-table-cell class="reportFont" md-label="ر.م">{{
                      i
                      }}</md-table-cell> -->
                      <md-table-cell
                        class="reportFont"
                        style="width: 400px"
                        md-label="البيان"
                        >{{ item.promotionType }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="الدرجة"
                        >{{ item.grade }}
                      </md-table-cell>

                      <md-table-cell
                        class="reportFont"
                        style="width: 250px"
                        md-label="العلاوة"
                      >
                        {{ item.bonuse }}</md-table-cell
                      >

                      <md-table-cell
                        class="reportFont"
                        style="width: 200px"
                        md-label="التاريخ "
                      >
                        {{ convert(item.date) }}
                      </md-table-cell>

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </div>

        <div style="direction: ltr" v-if="CurrentReport == 7">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 mt-25">
              <h3 class="text-center">تقرير الموظفين المستحقين لعلاوة سنوية</h3>
              <h4 class="text-center">
                {{ convert_Month(monthDate_R) }}
                <p style="display: initial">في شهر</p>
              </h4>
            </div>

            <div class="md-layout-item md-size-30">
              <h4 class="text-left" style="margin-left: 50px">
                التاريخ : {{ convert(new Date()) }}
              </h4>
            </div>

            <!-- <div class="md-layout-item md-size-30">
            <h3 class="text-right">{{ name.fullName }}</h3>
            <h4 class="text-right">{{ name.shortName }}</h4>
          </div> -->
          </div>
          <md-card-content style="padding: 16px 30px">
            <md-table
              dir="rtl"
              :value="staffReportData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover mt-25"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ر.م">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="الرقم الوظيفي">{{
                  item.jobNumber
                }}</md-table-cell>

                <md-table-cell class="w-200" md-label="الإسم">{{
                  item.employeeName
                }}</md-table-cell>

                <md-table-cell md-label="الوضع الوظيفي">{{
                  item.jobType
                }}</md-table-cell>

                <md-table-cell md-label="تاريخ التوظيف">{{
                  convert(item.jobDate)
                }}</md-table-cell>

                <md-table-cell md-label="المؤهل العلمي">{{
                  item.scientificDegree
                }}</md-table-cell>

                <md-table-cell md-label="التخصص">{{
                  item.specialization
                }}</md-table-cell>

                <md-table-cell md-label="العلاوة الحالية">{{
                  item.currentBonus
                }}</md-table-cell>

                <md-table-cell md-label="الدرجة الحالية">{{
                  item.currentGrade
                }}</md-table-cell>

                <!-- <md-table-cell md-label="تاريخ الحصول عليها">{{
                    item.lastBonusUpdate == null
                    ? ""
                    : convert(item.lastBonusUpdate)
                    }}</md-table-cell> -->

                <!-- <md-table-cell md-label="شهر العلاوة">{{
                  item.monthName
                }}</md-table-cell>

                <md-table-cell md-label="العلاوة المرقة لها">{{
                  item.dueBonus
                }}</md-table-cell> -->

                <md-table-cell md-label>
                  <div class="md-just-icon md-info md-simple"></div>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div
              style="
                padding: 9px 0px;
                background-color: #c3bebe;
                text-align: center;
              "
              class="table table-stats"
            >
              <div class="td-price">
                <span style="font-weight: bold">
                  عدد الموظفين =
                  <small style="font-weight: bold; font-size: 14px">{{
                    id_all
                  }}</small>
                </span>
              </div>
            </div>
          </md-card-content>
        </div>

        <!-- PDFReports -->

        <md-card-content>
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            filename="Social Solidarity"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a2"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            :html-to-pdf-options="{
              margin: [10, 10, st == 8 ? '5' : '5', 10],
              filename: stName,
              jsPDF: {
                format: `a2`,
                orientation:
                  CurrentReport == 11 || CurrentReport == 6
                    ? 'landscape'
                    : 'portrait'
              },
              html2canvas: {
                scale: 1,
                useCORS: true,
                dpi: 300,
                letterRendering: true
              }
            }"
            ref="html2Pdf"
            @beforeDownload="beforeDownload($event)"
            @progress="progressPdf($event)"
            @startPagination="startPagination"
            @hasPaginated="hasPaginated"
            @hasDownloaded="hasDownloaded($event)"
          >
            <section class="pdf-container d-flex" slot="pdf-content">
              <!-- PDF Content Here -->
              <CheckoutReport
                :TypeT="TypeT"
                :DateFrom="DateFrom"
                :DateTo="DateTo"
                :data="items"
                :allData="allData"
                v-if="CurrentReport == 16"
              />
              <nonPaidVacation
                :data="items"
                :allData="allData"
                v-if="CurrentReport == 14"
              />
              <Retirees
                :vacationYear="vacationYear"
                :data="items"
                :allData="allData"
                v-if="CurrentReport == 13"
              />
              <DelegatedEmployees
                :DelegationState="DelegationState"
                :data="items"
                :allData="allData"
                v-if="CurrentReport == 15"
              />

              <DailyReport
                :dateF="dateF"
                :name="companyName"
                :desc="companyDesc"
                :DepartmentId="DepartmentId"
                :countE="countE"
                :data="items"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 12"
              />

              <TimesheetD
                :Department="DepartmentIdTimesheet"
                :items="items"
                :alldata="allData"
                :date="DateFrom"
                :pathLogo="pathLogo"
                :DateTo="DateTo"
                :DepartmentId="DepartmentId"
                v-if="CurrentReport == 11 && IsWeekendDaysIncluded == true"
              />

              <TimesheetD_n
                :Department="DepartmentIdTimesheet"
                :items="items"
                :alldata="allData"
                :date="DateFrom"
                :DateTo="DateTo"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 11 && IsWeekendDaysIncluded == false"
              />

              <Timesheet
                :items="items"
                :alldata="allData"
                :date="dateF"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 10"
              />

              <TimesheetEmployee
                :items="items"
                :alldata="allData"
                :date="dateF"
                :pathLogo="pathLogo"
                :options="{
                  DateTo: DateTo,
                  DateFrom: DateFrom
                }"
                v-if="CurrentReport == 9"
              />

              <StaffLists
                :col_jobNumber="col_jobNumber"
                :col_nat="col_nat"
                :col_sci="col_sci"
                :col_d="col_d"
                :col_jop="col_jop"
                :col_current="col_current"
                :col_Grade="col_Grade"
                :col_Bonus="col_Bonus"
                :name="companyName"
                :desc="companyDesc"
                :DepartmentId="DepartmentId"
                :countE="countE"
                :data="pdfData"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 1"
              />

              <preparation
                :allData="socialSolidarities"
                :shortName="shortName"
                :fullName="fullName"
                :AboveGrade="AboveGrade_string"
                :Grade="Grade_string"
                :total="total_Head_Count"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 2"
              />

              <employeeCard
                :shortName="shortName"
                :fullName="fullName"
                :allData="socialSolidarities"
                :Date="convert(new Date())"
                :personalPicture="personalPicture"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 3"
              />

              <balance
                :allData="socialSolidarities"
                :shortName="shortName"
                :fullName="fullName"
                :Days="Days_R"
                :monthDate="convert_rtl(new Date())"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 4"
              />

              <careerPromotion
                :countE="countE"
                :allData="socialSolidarities"
                :shortName="shortName"
                :fullName="fullName"
                :AboveGrade="AboveGrade_string"
                :Grade="Grade_string"
                :monthDate="convert_Month(monthDate_R)"
                :pathLogo="pathLogo"
                v-if="CurrentReport == 6"
              />

              <vacationsReport
                :name="companyName"
                :vacationName="vacationName"
                :vacationYear="vacationYear"
                :desc="companyDesc"
                :data="items"
                v-if="CurrentReport == 5"
              />

              <div
                class="report-fss"
                style="direction: ltr"
                v-if="CurrentReport == 7"
              >
                <div style="margin-top: 200px" v-if="pathLogo == m"></div>

                <div class="mlogo t-alignlogo">
                  <img class="wlogo" :src="pathLogo" />
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-30">
                    <h4 class="text-left" style="margin-left: 50px">
                      التاريخ : {{ convert(new Date()) }}
                    </h4>
                  </div>

                  <div class="mt-25">
                    <h3 class="text-center fs-head-co">{{ name.fullName }}</h3>
                    <h4 class="text-center fs-head-co">{{ name.shortName }}</h4>

                    <h3 class="text-center fs-head">
                      تقرير الموظفين المستحقين لعلاوة سنوية
                    </h3>
                    <h4 class="text-center">
                      {{ convert_Month(monthDate_R) }}
                      <p style="display: initial">في شهر</p>
                    </h4>
                  </div>
                </div>
                <md-card-content style="padding: 16px 30px">
                  <md-table
                    dir="rtl"
                    :value="staffReportData"
                    :md-sort.sync="currentSort"
                    :md-sort-order.sync="currentSortOrder"
                    :md-sort-fn="customSort"
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                      <md-table-cell md-label="ر.م">{{
                        item.id
                      }}</md-table-cell>

                      <md-table-cell md-label="الرقم الوظيفي">{{
                        item.jobNumber
                      }}</md-table-cell>

                      <md-table-cell class="w-200" md-label="الإسم">{{
                        item.employeeName
                      }}</md-table-cell>

                      <md-table-cell md-label="الوضع الوظيفي">{{
                        item.jobType
                      }}</md-table-cell>

                      <md-table-cell md-label="تاريخ التوظيف">{{
                        convert(item.jobDate)
                      }}</md-table-cell>

                      <md-table-cell md-label="المؤهل العلمي">{{
                        item.scientificDegree
                      }}</md-table-cell>

                      <!-- <md-table-cell md-label="التخصص">{{
                            item.specialization
                          }}</md-table-cell> -->

                      <md-table-cell md-label="العلاوة الحالية">{{
                        item.currentBonus
                      }}</md-table-cell>

                      <md-table-cell md-label="الدرجة الحالية">{{
                        item.currentGrade
                      }}</md-table-cell>

                      <!-- <md-table-cell md-label="تاريخ الحصول عليها">{{
                            item.lastBonusUpdate == null
                              ? ""
                              : convert(item.lastBonusUpdate)
                          }}</md-table-cell> -->

                      <!-- <md-table-cell md-label="شهر العلاوة">{{
                            item.monthName
                          }}</md-table-cell> -->

                      <!-- <md-table-cell md-label="العلاوة المرقة لها">{{
                            item.dueBonus
                          }}</md-table-cell> -->

                      <md-table-cell md-label>
                        <div class="md-just-icon md-info md-simple"></div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                  <!-- <div
                        style="
                          padding: 9px 0px;
                          background-color: #c3bebe;
                          text-align: center;
                        "
                        class="table table-stats"
                      >
                        <div class="td-price">
                          <span style="font-weight: bold">
                            عدد الموظفين =
                            <small style="font-weight: bold; font-size: 14px">{{
                              id_all
                            }}</small>
                          </span>
                        </div>
                      </div> -->
                </md-card-content>
              </div>
            </section>
          </vue-html2pdf>

          <!-- should be disply block -->
          <div class="md-layout flex-content-left" style="display: none">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <!-- <div class="footer-table md-table">
                <table>
                  <tfoot>
                    <tr>
                      <th
                        v-for="item in footerTable"
                        :key="item.name"
                        class="md-table-head"
                      >
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">{{ item }}</div>
                        </div>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div> -->
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import {
  AtomSpinner,
  HollowDotsSpinner,
  LoopingRhombusesSpinner
} from "epic-spinners";

import ComprehensiveEmployeeReport from "@/components/Reports/ComprehensiveEmployeeReport.vue";

import Lodding from "../../../../Lodding.vue";

import employeeCard from "../../../../components/Reports/employeeCard.vue";
import nonPaidVacation from "../../../../components/Reports/nonPaidVacation.vue";
import Retirees from "../../../../components/Reports/Retirees.vue";
import DelegatedEmployees from "../../../../components/Reports/delegatedEmployees.vue";
import CheckoutReport from "../../../../components/Reports/CheckoutReport.vue";
import GetEmployeesAlllnfo from "../../../../components/Reports/GetEmployeesAlllnfo.vue";
import FunctionalData from "../../../../components/Reports/FunctionalData.vue";
import WorkFreeEmployees from "../../../../components/ViewReports/WorkFreeEmployees.vue";
import EndService from "../../../../components/ViewReports/EndService.vue";
import EmployeeEfficiencies from "../../../../components/ViewReports/EmployeeEfficiencies.vue";

import PersonalData from "../../../../components/Reports/PersonalData.vue";
import balance from "../../../../components/Reports/vacations_balance.vue";
import careerPromotion from "../../../../components/Reports/career_promotion.vue";
import preparation from "../../../../components/Reports/Staff_preparation.vue";
import StaffLists from "../../../../components/Reports/StaffLists.vue";
import ViewStaffLists from "../../../../components/ViewReports/ViewStaffLists.vue";
import vacationsReport from "../../../../components/Reports/vacationsReport.vue";

import MonthlyVariables from "../../../../components/Reports/monthlyVariables.vue";
import ViewMonthlyVariables from "../../../../components/ViewReports/ViewMonthlyVariables.vue";

import PromotionsReportExcel from "../../../../components/ExcelReports/PromotionsReportExcel.vue";
import EmployeeCardReportExcel from "../../../../components/ExcelReports/EmployeeCardReportExcel.vue";
import StaffListsReportExcel from "../../../../components/ExcelReports/StaffListsReportExcel.vue";
import BonusesReportExcel from "../../../../components/ExcelReports/BonusesReportExcel.vue";
import ViewEmployeeCard from "../../../../components/ViewReports/ViewEmployeeCard.vue";
import ViewPreparation from "../../../../components/ViewReports/ViewPreparation.vue";
import ViewVacationsBalance from "../../../../components/ViewReports/ViewVacationsBalance.vue";
import ViewCareerPromotion from "../../../../components/ViewReports/ViewCareerPromotion.vue";
import Timesheet from "../../../../components/Reports/Timesheet.vue";
import TimesheetD from "../../../../components/Reports/TimesheetD.vue";
import TimesheetD_n from "../../../../components/Reports/TimesheetD_n.vue";
import DailyReport from "../../../../components/Reports/DailyReport.vue";
import ViewTimesheetD from "../../../../components/ViewReports/ViewTimesheetD.vue";

import ViewTimesheet from "../../../../components/ViewReports/ViewTimesheet.vue";
import ViewTimesheetStatus from "../../../../components/ViewReports/ViewTimesheetStatus.vue";

import TimesheetEmployee from "../../../../components/Reports/TimesheetEmployee.vue";

import StepProgress from "vue-step-progress";
import VueHtml2pdf from "vue-html2pdf";

// import { AtomSpinner } from "epic-spinners";
// import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import { ModelListSelect, ModelListOption } from "vue-search-select";
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import env from "../../../../../env";
export default {
  name: "StaffReports",
  components: {
    ComprehensiveEmployeeReport,
    GetEmployeesAlllnfo,
    WorkFreeEmployees,
    EndService,
    EmployeeEfficiencies,
    Lodding,
    DailyReport,
    Timesheet,
    TimesheetD,
    TimesheetD_n,
    ViewTimesheetD,
    ViewTimesheet,
    ViewTimesheetStatus,
    TimesheetEmployee,
    Pagination,
    ModelListSelect,
    VueHtml2pdf,
    employeeCard,
    balance,
    careerPromotion,
    preparation,
    StaffLists,
    ViewStaffLists,
    nonPaidVacation,
    Retirees,
    DelegatedEmployees,
    CheckoutReport,
    FunctionalData,
    PersonalData,
    vacationsReport,
    PromotionsReportExcel,
    EmployeeCardReportExcel,
    StaffListsReportExcel,
    BonusesReportExcel,
    ViewEmployeeCard,
    ViewPreparation,
    ViewVacationsBalance,
    ViewCareerPromotion,
    MonthlyVariables,
    ViewMonthlyVariables,

    ///////

    AtomSpinner
    // StepProgress,
  },
  computed: {
    filterCurrentReportList() {
      return array => {
        let result = array.filter(x => {
          if (this.isMultiShiftsEnabled == "true") {
            return x.id !== "11";
          }
          return true;
        });

        return result;
      };
    },
    globalEmployeesData() {
      return this.$store.getters["global/employeesData"];
    },
    globalCompanyInfo() {
      return this.$store.getters["global/companyInfo"];
    },
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
    // حساب إجمالي قيمة الخصم لتقرير خصم التأخير والغياب
    // totalDiscountValue() {
    //   if (!this.delayAbsenceDeductionData.length) return 0;
    //   const sum = this.delayAbsenceDeductionData.reduce((acc, item) => {
    //     const value = parseFloat(item.totalDiscountValue) || 0;
    //     return acc + value;
    //   }, 0);
    //   return Math.round(sum * 1000) / 1000;
    // },
    // حساب عدد ساعات الحضور لتقرير خصم التأخير والغياب (الفرق بين timeOut و timeIn)
    // totalAttendanceHours() {
    //   if (!this.delayAbsenceDeductionData.length) return "00:00:00";
    //   let totalSeconds = 0;
    //   this.delayAbsenceDeductionData.forEach((item) => {
    //     if (item.timeIn && item.timeOut) {
    //       const timeInParts = item.timeIn.split(":");
    //       const timeOutParts = item.timeOut.split(":");
    //       const timeInSeconds =
    //         parseInt(timeInParts[0]) * 3600 +
    //         parseInt(timeInParts[1]) * 60 +
    //         parseInt(timeInParts[2] || 0);
    //       const timeOutSeconds =
    //         parseInt(timeOutParts[0]) * 3600 +
    //         parseInt(timeOutParts[1]) * 60 +
    //         parseInt(timeOutParts[2] || 0);
    //       const diff = timeOutSeconds - timeInSeconds;
    //       if (diff > 0) totalSeconds += diff;
    //     }
    //   });
    //   const hours = Math.floor(totalSeconds / 3600);
    //   const minutes = Math.floor((totalSeconds % 3600) / 60);
    //   const seconds = totalSeconds % 60;
    //   return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    //     2,
    //     "0"
    //   )}:${String(seconds).padStart(2, "0")}`;
    // },
    // حساب عدد ساعات التأخير لتقرير خصم التأخير والغياب (مجموع delayValue)
    // totalDelayHours() {
    //   if (!this.delayAbsenceDeductionData.length) return "00:00:00";
    //   let totalSeconds = 0;
    //   this.delayAbsenceDeductionData.forEach((item) => {
    //     if (item.delayValue) {
    //       const parts = item.delayValue.split(":");
    //       totalSeconds +=
    //         parseInt(parts[0]) * 3600 +
    //         parseInt(parts[1]) * 60 +
    //         parseInt(parts[2] || 0);
    //     }
    //   });
    //   const hours = Math.floor(totalSeconds / 3600);
    //   const minutes = Math.floor((totalSeconds % 3600) / 60);
    //   const seconds = totalSeconds % 60;
    //   return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    //     2,
    //     "0"
    //   )}:${String(seconds).padStart(2, "0")}`;
    // },
  },

  data() {
    return {
      endedServiceEmployeeId: null,
      endedServiceEmployeesList: [],
      privateCompanyMode: "false",
      privateCompanyStyle: false,
      isMultiShiftsEnabled: false,
      CurrentReportList: [
        {
          id: "21",
          name: "التقرير الشامل للموظف"
        },

        {
          id: "2",
          name: "تقرير بأعداد الموظفين حسب الادارة"
        },
        {
          id: "3",
          name: "بطاقة الموظف"
        },

        {
          id: "4",
          name: "كشف برصيد الإجازة السنوية"
        },

        {
          id: "5",
          name: "تقرير الإجازات"
        },

        {
          id: "6",
          name: "تقرير الترقيات"
        },

        {
          id: "7",
          name: "العلاوات السنوية"
        },

        {
          id: "8",
          name: "الحصيلة الشهرية"
        },
        {
          id: "16",
          name: "تقرير الحضور والانصراف العام"
        },

        {
          id: "9",
          name: "تقرير الحضور والانصراف لموظف"
        },

        {
          id: "10",
          name: "تقرير جدول الحضور والانصراف"
        },
        {
          id: "11",
          name: "تقرير الحضور والانصراف التفصيلي"
        },

        {
          id: "12",
          name: "تقرير الحضور والانصراف اليومي"
        },

        {
          id: "13",
          name: "تقرير المحالين على التقاعد"
        },
        {
          id: "14",
          name: "كشف الإجازة بدون مرتب"
        },

        {
          id: "15",
          name: "كشف المنتدبين"
        },

        {
          id: "19",
          name: "حركة ترقيات الموظف"
        },

        {
          id: "20",
          name: "كشف الموظفين المتفرغين"
        },

        {
          id: "22",
          name: "تقرير المنتهي خدمتهم"
        },

        {
          id: "23",
          name: "تقرير الكفاءة السنوية"
        },

        {
          id: "24",
          name: "تقرير الإفادة الإدارية"
        },
        {
          id: "25",
          name: "تقرير خصم التأخير والغياب"
        },
        {
          id: "26",
          name: "حالة جدول الحضور والانصراف"
        },
        {
          id: "27",
          name: "حالة حضور الموظف"
        }
      ],

      CurrentReportList_true: [
        {
          id: "21",
          name: "التقرير الشامل للموظف"
        },

        {
          id: "2",
          name: "تقرير بأعداد الموظفين حسب الادارة"
        },
        {
          id: "3",
          name: "بطاقة الموظف"
        },

        {
          id: "4",
          name: "كشف برصيد الإجازة السنوية"
        },

        {
          id: "5",
          name: "تقرير الإجازات"
        },

        {
          id: "8",
          name: "الحصيلة الشهرية"
        },
        {
          id: "16",
          name: "تقرير الحضور والانصراف العام"
        },

        {
          id: "9",
          name: "تقرير الحضور والانصراف لموظف"
        },

        {
          id: "10",
          name: "تقرير جدول الحضور والانصراف"
        },
        {
          id: "11",
          name: "تقرير الحضور والانصراف التفصيلي"
        },

        {
          id: "12",
          name: "تقرير الحضور والانصراف اليومي"
        },

        {
          id: "14",
          name: "كشف الإجازة بدون مرتب"
        },

        {
          id: "20",
          name: "كشف الموظفين المتفرغين"
        },

        {
          id: "22",
          name: "تقرير المنتهي خدمتهم"
        },

        {
          id: "23",
          name: "تقرير الكفاءة السنوية"
        },

        {
          id: "24",
          name: "تقرير الإفادة الإدارية"
        },
        {
          id: "25",
          name: "تقرير خصم التأخير والغياب"
        },
        {
          id: "26",
          name: "حالة جدول الحضور والانصراف"
        },
        {
          id: "27",
          name: "حالة حضور الموظف"
        }
      ],
      endEmployees: [],
      typeEndService: null,
      LetterNumber: null,
      Reason: null,
      IsEndedService: false,
      OrderByJobNumber: false,
      TypeOfEndService: "",
      JobDescription: "",
      DepartmentClassificationsId: "",
      JobType: "",
      ReportAddress: "",

      filter: [],
      arabicName: [],
      enName: [],
      col_pdf: [
        {
          arabicName: "التصنيف الوظيفي",
          enName: "JobtitelClassification",
          privateCompanyMode: true,
          type: "enum",
          values: [
            {
              title: "موظف",
              value: "0"
            },
            {
              title: "مدير إدارة",
              value: "1"
            },
            {
              title: "رئيس قسم",
              value: "2"
            },
            {
              title: "رئيس وحدة",
              value: "3"
            },
            {
              title: "مدير عام",
              value: "4"
            }
          ]
        },
        {
          arabicName: "رقم جواز السفر",
          enName: "PassportNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "مكان اصدار جواز السفر",
          enName: "PassportIssuePlace",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ اصدار جواز السفر",
          enName: "PassportIssueDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الرقم الالي لجواز السفر",
          enName: "PassportAutoNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم البطاقة الشخصية",
          enName: "IdentificationCardNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "مكان اصدارالبطاقة الشخصية ",
          enName: "IdentificationCardIssuePlace",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ اصدارالبطاقة الشخصية ",
          enName: "IdentificationCardIssueDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم كتيب العائلة",
          enName: "BookletNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "مكان اصدار كتيب العائلة ",
          enName: "BookletIssuePlace",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ اصدار كتيب العائلة",
          enName: "BookletIssueDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم ورقة العائلة",
          enName: "BookletFamilyNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم القيد",
          enName: "BookletRegistrationFamilyNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "السجل المدني المسؤول",
          enName: "BookletCivilRegister",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "البريد الالكتروني",
          enName: "Email",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "عدد الاطفال ",
          enName: "ChilderCount",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "جنسية الزوجة",
          enName: "NationalityMarriedString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "اسم الزوجة",
          enName: "NameMarried",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الحالة الاجتماعية",
          enName: "SocialStatusString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "اسم الام",
          enName: "MotherName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "مكان الميلاد",
          enName: "BirthPlace",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ الميلاد",
          enName: "BirthDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ انتهاء صلاحية التأشيرة",
          enName: "VisaExpiryDate",
          privateCompanyMode: true,
          type: "fromTo",
          values: null
        },
        {
          arabicName: "رقم الهاتف",
          enName: "Phone",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "العنوان",
          enName: "Address",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الجنس",
          enName: "GenderString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "نوع الجنسية",
          enName: "NationalityTypeString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الجنسية",
          enName: "NationalityName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الرقم الوطني ",
          enName: "NationalNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم الموظف",
          enName: "JobNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم الملف الشخصي",
          enName: "ProfileNumber",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رقم الملاك الوظيفي",
          enName: "EmploymentNumber",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "الادارة",
          enName: "ManagementName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "القسم",
          enName: "SectionName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الوحدات",
          enName: "UnitName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الوضع الحالي",
          enName: "CurrentSituationString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "نوع التوظيف",
          enName: "JobTypeString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ المباشرة",
          enName: "StartingDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ التعاقد",
          enName: "EmploymentDate",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ بداية العقد",
          enName: "ContractDateFrom",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ نهاية العقد",
          enName: "ContractDateTo",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الزيادة الشهرية للاجازة السنوية",
          enName: "MonthlyIncreaseOfVacation",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الوظيفة",
          enName: "Job",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "مكان العمل",
          enName: "Workplace",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الدرجة الحالية",
          enName: "CurrentGradeString",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "سبب الدرجة الحالية",
          enName: "ReasonForCurrentGradeString",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "العلاوة الادارية",
          enName: "CurrentBonus",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "شهر العلاوة",
          enName: "BonusDueDate",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ الدرجة الحالية",
          enName: "LastGradeUpdate",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ استحقاق الترقية",
          enName: "UpgradeDueDate",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "الدوام الرسمي",
          enName: "ShiftName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الدوام الثاني",
          enName: "SecondaryShiftName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الدوام الثالث",
          enName: "ThirdShiftName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الصفة الوظيفية",
          enName: "JobTitle",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "صفة الرئيس المباشر",
          enName: "DirectManagerJobTitleName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "صفة الرئيس الأعلى",
          enName: "TopLevelManager",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "المؤهل العلمي",
          enName: "ScientificDegreeName",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "التخصص",
          enName: "Specialization",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "جهة اصدار المؤهل العلمي",
          enName: "CertificateProviderOrganization",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "سنة الحصول على المؤهل العلمي",
          enName: "ScientificDegreeYear",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ قرار التعيين",
          enName: "EmploymentDate",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "رقم قرار التعيين",
          enName: "DesignationDecisionNumber",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "جهة اصدار التعيين",
          enName: "Appointment",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "الوضع الوظيفي عند التعيين",
          enName: "JobStatusAppointment",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "المؤهل العلمي عند التعيين",
          enName: "ScientificAppointment",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "سنة الحصول على المؤهل ",
          enName: "ScientificAppointmentYear",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الدرجة عند التوظيف",
          enName: "GradeAppointment",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "التخصص عند التعيين",
          enName: "ScientificAppointment",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "تاريخ شغل الوظيفية",
          enName: "StartingDateAtWorkToString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "طريقة شغل الوظيفة",
          enName: "JobDescriptionString",
          privateCompanyMode: false,
          type: null,
          values: null
        },
        {
          arabicName: "جهة العمل السابقة",
          enName: "PreviousEmployer",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الكفاءة السنوية 1",
          enName: "EfficiencyString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الكفاءة السنوية 2",
          enName: "EfficiencyTwoString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "الكفاءة السنوية 3",
          enName: "EfficiencyThreeString",
          privateCompanyMode: true,
          type: null,
          values: null
        },
        {
          arabicName: "رصيد الأجازة السنوية",
          enName: "YearlyVecationBalance",
          privateCompanyMode: true,
          type: null,
          values: null
        }
      ],
      lodding_bool: false,
      EmployeeName: "",
      JobNumber: "",
      Department: "",
      CurrentGrade: "",
      CurrentGradeDate: "",
      CurrentGradeDecisionNumber: "",
      CurrentGradeDecisionSource: "",
      GradeAppointment: "",
      GradeAppointmentDate: "",
      GradeAppointmentDecisionNumber: "",
      GradeAppointmentDecisionSource: "",

      personalPicture: true,
      FilterDeparmentClassificationsIds: [],
      deparmentClassifications: [],
      IsWeekendDaysIncluded: false,
      FromTime: null,
      ToTime: null,
      JobtitelClassification: "",
      m: env.mTop(),
      col_jobNumber: true,
      col_nat: true,
      col_sci: true,
      col_d: true,
      col_jop: true,
      col_current: true,
      col_Grade: true,
      col_Bonus: true,

      SectionId: "",
      DelegationState: "",
      departmentsLoad: [],
      jobTitles: [],

      JobTitleID_load: "",
      JobTitle_load: [],
      items: [],
      pathLogo: "",
      monthlyVariables: [],
      countEmployee: 0,
      n_date: null,
      departments: [],
      errorMessage: "",
      total_Head_Count: 0,
      // TODO: make it zero "0" Again
      CurrentReport: "0",
      employees: [],
      vacationTypes: [],
      vacationYear: "",
      vacationId: "",
      vacationName: "",
      FullName_report: "",
      stName: "",
      socialSolidarities: "",
      fullName: "",
      shortName: "",
      Grade_string: "الاولى",
      AboveGrade_string: "مايعلوها",
      MonthDate_4: "",
      Days_R: "",
      monthDate_R: null,
      Grade: "",
      AboveGrade: true,

      ///////////////////////////
      htmlToPdfOptions: {
        margin: [10, 10, 51, 10],
        filename: `momen.pdf`,
        jsPDF: {
          format: "a2",
          orientation: "portrait"
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          dpi: 300,
          letterRendering: true
        }
      },
      id_all: 0,
      st: 0,
      allBanks: [],
      selectBank: "",
      allBankBranches: [],
      selectBankBranch: "",
      pdfLoadingActive: false,
      generalAnalytical: {},
      salariesChequeData: [], // حافظة ارفاق صك
      allPaymentPerMonth: [], // صرف رواتب عن شهر
      mySteps: ["بدء التحميل", "جارى التحميل", "تم التحميل"],
      currentStep: 0,
      staffReportData: [],
      name: [],

      isActive: false,
      id: localStorage.getItem("idTable"),

      one: true,
      tow: false,

      IsAll: false,
      IsAllEmployees: false,
      AllEmployees: [],
      EmployeeId: "",
      EmployeeIdTimesheet: null,
      endEmployeesId: "",
      DepartmentIdTimesheet: null,
      TypeId: "00000000-0000-0000-0000-000000000000",
      StartOn: null,
      FinishOn: null,
      Note: "",
      Type: "",
      employeeFullName: "",
      tableData: [],
      btn: "new",
      idTable: "",
      updateStatus: "",
      balance: 0,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
      CurrentPage: "",
      Types: [],
      StartingBonus: "",
      StartingGrade: "",
      dateFrom: null,
      dateF: "",
      dateTo: null,
      DateFrom: null,
      DateTo: null,
      TypeT: null,
      allData: null,
      companyName: "",
      companyDesc: "",
      pdfData: [],
      countE: "",

      FullName: "",
      DepartmentId: null,
      departmentClassification: "",
      ScientificDegreeId: "",
      NationalNumber: "",
      StartingDateFrom: "",
      StartingDateTo: "",
      SortBy: "0",
      BonusDueDateFilterType: "",
      PageSize: null,
      MustRetireSoon: false,
      theToken: localStorage.getItem("Nannotoken"),
      reportUrl: "https://nanosoft.live/hr-reports/api",
      delayAbsenceDeductionData: [],
      totalAttendanceTime: 0,
      totalDelayValues: 0,
      totalDiscountValue: 0,
      timesheetStatusData: [],
      timeSheetDurationStatus: null,

      // تقرير حالة حضور الموظف (27)
      attendanceSearchMode: 1,
      workplaceId: null,
      workPlacesList: [],
      attendanceStatusData: [],
      attendanceEmployeeName: "",
      attendanceWorkPlaceName: ""
    };
  },

  watch: {
    EmployeeIdTimesheet(newValue) {
      if (newValue) {
        this.endedServiceEmployeeId = newValue;
      }
    },
    endedServiceEmployeeId(newValue) {
      if (newValue) {
        this.EmployeeIdTimesheet = newValue;
      }
    },
    globalEmployeesData(newValue) {
      this.init();
    },
    globalCompanyInfo(newValue) {
      this.getCompanyInfo();
    },
    async DepartmentId() {
      try {
        if (this.DepartmentId != null) {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/departments/${this.DepartmentId}/load`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.departmentsLoad = result.data.data;

          let result_JobTitle = await axios.get(
            `${env.HR()}/api/Job-title/${this.DepartmentId}/load`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.jobTitles = result_JobTitle.data.data;
        }
      } catch (error) {
        return this.notifyVue("top", "center", "danger", error);
      }
    },

    AboveGrade() {
      if (this.AboveGrade == "true") {
        this.AboveGrade_string = "مايعلوها";
      } else {
        this.AboveGrade_string = "مادونها";
      }
    },
    Grade() {
      if (this.Grade == "1") {
        this.Grade_string = "الاولى";
      } else if (this.Grade == "2") {
        this.Grade_string = "التانية";
      } else if (this.Grade == "3") {
        this.Grade_string = "الثالتة";
      } else if (this.Grade == "4") {
        this.Grade_string = "الرابعة";
      } else if (this.Grade == "5") {
        this.Grade_string = "الخامسة";
      } else if (this.Grade == "6") {
        this.Grade_string = "السادسة";
      } else if (this.Grade == "7") {
        this.Grade_string = "السابعة";
      } else if (this.Grade == "8") {
        this.Grade_string = "الثامنة";
      } else if (this.Grade == "9") {
        this.Grade_string = "التاسعة";
      } else if (this.Grade == "10") {
        this.Grade_string = "العاشرة";
      } else if (this.Grade == "11") {
        this.Grade_string = "الحادية عشر";
      } else if (this.Grade == "12") {
        this.Grade_string = "التانية عشر";
      } else if (this.Grade == "13") {
        this.Grade_string = "الثالتة عشر";
      } else {
        this.Grade_string = "الرابعة عشر";
      }
    },

    async CurrentReport() {
      if (this.CurrentReport == "22") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let EndedServiceEmployees = await axios.get(
          `${env.HR()}/api/hr/Employees/EndedServiceEmployees`,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        this.endEmployees = EndedServiceEmployees.data.data.employees;
      }

      if (this.CurrentReport == "24") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let AllEmployees = await axios.get(
          `${env.HR()}/api/hr/Employees/GetAllEmployees`,
          {
            headers: { Authorization: "Bearer " + token }
          }
        );
        this.AllEmployees = AllEmployees.data.data;
      }
    }
    // CurrentReport(newValue) {

    //   this.socialSolidarities = [];
    //   this.EmployeeIdTimesheet = null;
    //   switch (+newValue) {
    //     case 1:
    //       this.stName = "تقرير الموظفين";
    //       break;
    //     case 2:
    //       this.stName = "تقرير بأعداد الموظفين حسب الادارة";
    //       break;

    //     case 3:
    //       this.stName = "بطاقة الموظف";
    //       break;

    //     case 4:
    //       this.stName = "كشف برصيد الإجازة السنوية";
    //       break;

    //     case 5:
    //       this.stName = "تقرير الإجازات";
    //       break;

    //     case 6:
    //       this.stName = "الترقيات";
    //       break;

    //     case 7:
    //       this.stName = "العلاوات السنوية";
    //       break;

    //     case 8:
    //       this.stName = "الحصيلة الشهرية";
    //       break;

    //     case 9:
    //       this.stName = "تقرير الحضور والانصراف لموظف";
    //       break;

    //     case 10:
    //       this.stName = "تقرير جدول الحضور والانصراف";
    //       break;

    //     case 11:
    //       this.stName = "تقرير الحضور والانصراف التفصيلي";
    //       break;

    //     case 12:
    //       this.stName = "تقرير الحضور والانصراف اليومي";
    //       break;

    //     case 13:
    //       this.stName = "تقرير المحالين على التقاعد";
    //       break;

    //     case 14:
    //       this.stName = " كشف الموظفين الحاليين أصحاب الإجازة بدون مرتب";
    //       break;

    //     case 15:
    //       this.stName = "كشف المنتدبين";
    //       break;

    //     case 16:
    //       this.stName = " تقرير الحضور والانصراف العام";
    //       break;

    //     default:
    //       break;
    //   }
    // },
  },

  async created() {
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
    this.isMultiShiftsEnabled = localStorage.getItem("isMultiShiftsEnabled");

    const styleValue = localStorage.getItem("privateCompanyMode");
    this.privateCompanyStyle = styleValue === "true";
  },
  async mounted() {
    this.fetchEndedServiceEmployees();
    this.fetchWorkPlaces();
    if (this.globalEmployeesData) {
      await this.init();
    }
    if (this.globalCompanyInfo) {
      await this.getCompanyInfo();
    }
  },
  methods: {
    async printDelayCheckinEarlyCheckoutReport(type) {
      try {
        if (!this.DateFrom) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال التاربخ من"
          );
        }

        if (!this.DateTo) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال التاربخ إلى"
          );
        }

        if (!this.TypeT) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار النوع "
          );
        }

        const types = {
          0: "pdf",
          1: "excel"
        };

        const reportType = types[type];

        let schema = {
          reportType,
          EmployeeId:
            this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
          From:
            this.DateFrom == null
              ? null
              : moment(this.DateFrom).format("YYYY-MM-DD[T]hh:mm:ss"),
          To:
            this.DateTo == null
              ? null
              : moment(this.DateTo).format("YYYY-MM-DD[T]hh:mm:ss"),
          Type: parseInt(this.TypeT),
          DepartmentId: this.DepartmentIdTimesheet,
          FilterDeparmentClassificationsIds:
            this.FilterDeparmentClassificationsIds == ""
              ? null
              : this.FilterDeparmentClassificationsIds
        };

        const result = await this.$axios.patch(
          "/api/hr/Timesheet/DelayCheckinandEarlyCheckoutReportFile",
          schema,
          {
            responseType: "blob"
          }
        );

        // Create a new Blob object using the response data
        const blob = new Blob([result.data]);

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = `تقرير الحضور والإنصراف العام.${
          reportType === "excel" ? "xlsx" : "pdf"
        }`;

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {}
    },
    async fetchEndedServiceEmployees() {
      try {
        const { data } = await this.$axios.get(
          "/api/hr/Employees/EndedServiceEmployees"
        );

        this.endedServiceEmployeesList = data.data.employees;
      } catch (error) {}
    },
    clearfield(field) {
      this[field] = null;
    },
    async init() {
      this.vacationTypes = this.globalEmployeesData.vacationTypes;
      this.departments = this.globalEmployeesData.departments;
      this.departmentClassification = this.globalEmployeesData.departmentClassifications;
      this.scientificDegrees = this.globalEmployeesData.scientificDegrees;
      this.employees = this.globalEmployeesData.employees;
      this.jobTitles = this.globalEmployeesData.jobTitles;
    },
    handleParamsForReport21(filter) {
      // const queryString = JSON.stringify(filter);

      if (filter.length > 14) {
        this.lodding_bool = false;
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، يجب تحديد 14 عمود على الاكثر "
        );
      }

      let params = {
        Id: this.EmployeeIdTimesheet || null,
        DepartmentId: this.DepartmentId || null,
        SectionId: this.SectionId || null,
        JobtitelClassification: this.JobtitelClassification || null,
        JobTitleID_load: this.JobTitleID_load || null,
        DepartmentClassificationsId: this.DepartmentClassificationsId || null,
        JobType: this.JobType || null,
        JobDescription: this.JobDescription || null,
        TypeOfEndService: this.TypeOfEndService || null,
        IsEndedService: this.IsEndedService || null,
        OrderByJobNumber: this.OrderByJobNumber || null,
        ReportAddress: this.ReportAddress || null,
        bankId: null,
        bankBranchId: null,
        JobTitleID: null,
        fullName: null,
        NationalNumber: null,
        jobNumber: null,
        nationalityId: null,
        ScientificDegreeId: null,
        profileNumber: null,
        jobDate: null,
        columns: this.filter.map(m => m.enName),
        filters: filter
      };

      return params;
    },

    // طباعة تقرير اكسل للتقرير الشامل للموظف
    async generateExcelFileForReport21(filter) {
      const schema = this.handleParamsForReport21(filter);

      let params = {
        ReportType: "Excel",
        ...schema
      };

      this.downloadReport21(params);
    },

    // طباعة تقرير Pdf للتقرير الشامل للموظف
    async generatePdfFileForReport21(filter) {
      const schema = this.handleParamsForReport21(filter);

      let params = {
        ReportType: "PDF",
        ...schema
      };

      this.downloadReport21(params);
    },

    async downloadReport21(params) {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        this.lodding_bool = true;

        const urlApi = `${env.HR()}/api/hr/EmployeesReport/GetEmployeesAlllnfoReport`;

        const response = await axios.put(urlApi, params, {
          headers: { Authorization: "Bearer " + token },
          responseType: "blob" // Important to handle binary data
        });

        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename

        if (params.ReportType === "PDF") {
          link.download = "التقرير الشامل للموظف.pdf";
        } else {
          link.download = "التقرير الشامل للموظف.xlsx";
        }

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
        this.lodding_bool = false;
      }
    },

    // تقرير الحضور والانصراف لموظف
    async getEmployeeInOut(type) {
      try {
        this.lodding_bool = true;
        if (!this.EmployeeIdTimesheet) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف "
          );
        }

        const types = {
          0: "pdf",
          1: "excel"
        };

        const reportType = types[type];

        const params = {
          employeeId: this.EmployeeIdTimesheet,
          fromDate: moment(this.DateFrom).format("YYYY-MM-DD"),
          toDate: moment(this.DateTo).format("YYYY-MM-DD"),
          reportType
        };

        const urlApi = `/api/timesheet-self-service/ReportPdf`;

        const employee = this.employees.find(
          emp => emp.key === params.employeeId
        );

        const fileName = `تقرير الحضور والانصراف لموظف - ${employee?.value}.${
          reportType === "excel" ? "xlsx" : "pdf"
        }`;

        const { data } = await this.$axios.get(urlApi, {
          params,
          responseType: "blob"
        });

        // Create a new Blob object using the response data
        const blob = new Blob([data], { type: "application/pdf" });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = fileName;

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        console.error("Error downloading the PDF", error);
        this.lodding_bool = false;
      }
    },

    // تقرير خصم التأخير والغياب
    async getDelayAbsenceDeduction(type) {
      if (!this.EmployeeIdTimesheet) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء اختيار الموظف "
        );
      }

      if (!this.DateFrom) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال تاريخ من "
        );
      }

      if (!this.DateTo) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال تاريخ الى "
        );
      }

      this.lodding_bool = true;
      try {
        const types = {
          0: "pdf",
          1: "excel"
        };

        const reportType = types[type];

        const schema = {
          employeeId: this.EmployeeIdTimesheet,
          fromDate: moment(this.DateFrom).format("YYYY-MM-DD"),
          toDate: moment(this.DateTo).format("YYYY-MM-DD"),
          reportType
        };

        const fileName = `تقرير خصم التأخير والغياب.${
          reportType === "excel" ? "xlsx" : "pdf"
        }`;

        const { data } = await this.$axios.patch(
          "/api/hr/Timesheet/InOutDeductionsFile",
          schema,
          {
            responseType: "blob"
          }
        );

        // Create a new Blob object using the response data
        const blob = new Blob([data], {
          type:
            reportType === "excel"
              ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              : "application/pdf"
        });

        // Create a link element
        const link = document.createElement("a");

        // Create a URL for the Blob and set it as the href attribute of the link
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        // Set the download attribute with a filename
        link.download = fileName;

        // Append the link to the document body (it won't be visible)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up by removing the link and revoking the object URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        let message = "حدث خطأ في تنزيل التقرير";
        try {
          if (error && error.response) {
            const data = error.response.data;
            if (data && typeof data.text === "function") {
              const text = await data.text();
              try {
                const json = JSON.parse(text);
                message = json.message || message;
              } catch (_) {
                message = text || message;
              }
            } else if (data && data.message) {
              message = data.message;
            } else if (typeof data === "string") {
              message = data;
            }
          } else if (error && error.message) {
            message = error.message;
          }
        } catch (_) {}
        return this.notifyVue("top", "center", "danger", message);
      }
    },

    // بحث في تقرير خصم التأخير والغياب
    async searchDelayAbsenceDeduction() {
      if (!this.EmployeeIdTimesheet) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء اختيار الموظف "
        );
      }

      if (!this.DateFrom) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال تاريخ من "
        );
      }

      if (!this.DateTo) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال تاريخ الى "
        );
      }

      this.lodding_bool = true;
      try {
        const { data } = await this.$axios.get(
          "/api/hr/Timesheet/InOutDeductions",
          {
            params: {
              EmployeeId: this.EmployeeIdTimesheet,
              FromDate: moment(this.DateFrom).format("YYYY-MM-DD"),
              ToDate: moment(this.DateTo).format("YYYY-MM-DD")
            }
          }
        );

        this.delayAbsenceDeductionData = data.data.data;
        this.totalAttendanceTime = data.data.totalAttendanceTime;
        this.totalDelayValues = data.data.totalDelayValues;
        this.totalDiscountValue = data.data.totalDiscountValue;
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        console.error(
          "Error fetching delay absence deduction data",
          error.response.data.message
        );
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    // بحث في تقرير حالة جدول الحضور والانصراف
    async searchTimesheetStatus() {
      if (!this.DateFrom) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء ادخال تاريخ من "
        );
      }

      if (!this.DateTo) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء ادخال تاريخ الى "
        );
      }

      if (!this.timeSheetDurationStatus) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء اختيار الحالة "
        );
      }

      this.lodding_bool = true;
      try {
        const params = {
          From: moment(this.DateFrom).format("YYYY-MM-DD"),
          To: moment(this.DateTo).format("YYYY-MM-DD"),
          TimeSheetDurationStatus: parseInt(this.timeSheetDurationStatus)
        };

        if (this.EmployeeIdTimesheet) {
          params.EmployeeId = this.EmployeeIdTimesheet;
        }

        const { data } = await this.$axios.get(
          "/api/hr/Timesheet/TimeSheetStatusReport",
          {
            params
          }
        );

        this.timesheetStatusData = data.data.items;
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    // تصدير تقرير حالة جدول الحضور والانصراف
    async exportTimesheetStatus() {
      if (!this.DateFrom) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء ادخال تاريخ من "
        );
      }

      if (!this.DateTo) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء ادخال تاريخ الى "
        );
      }

      if (!this.timeSheetDurationStatus) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "عفواً، الرجاء اختيار الحالة "
        );
      }

      this.lodding_bool = true;
      try {
        const schema = {
          EmployeeId: this.EmployeeIdTimesheet || null,
          From: moment(this.DateFrom).format("YYYY-MM-DD"),
          To: moment(this.DateTo).format("YYYY-MM-DD"),
          TimeSheetDurationStatus: parseInt(this.timeSheetDurationStatus)
        };

        const { data } = await this.$axios.patch(
          "/api/hr/Timesheet/TimeSheetStatusReportFile",
          schema,
          {
            responseType: "blob"
          }
        );

        const blob = new Blob([data], {
          type: "application/pdf"
        });

        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;

        link.download = "حالة جدول الحضور والانصراف.pdf";

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        let message = "حدث خطأ في تنزيل التقرير";
        try {
          if (error.response && error.response.data) {
            const data = error.response.data;
            if (data.message) {
              message = data.message;
            }
          }
        } catch (_) {}
        return this.notifyVue("top", "center", "danger", message);
      }
    },

    async fetchWorkPlaces() {
      try {
        const { data } = await this.$axios.get("/api/workPlaces");
        this.workPlacesList = (data.data || []).map(wp => ({
          id: wp.id,
          name: wp.name
        }));
      } catch (error) {
        console.error("Error fetching workplaces", error);
      }
    },

    isOnline(status) {
      if (!status) return false;
      return String(status).trim() === "متصل";
    },

    syncLabel(isMobileSynced) {
      if (isMobileSynced) {
        return "متزامن";
      }
      return "غير متزامن";
    },

    async searchAttendanceStatus() {
      if (this.attendanceSearchMode === 1) {
        if (!this.EmployeeIdTimesheet) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف"
          );
        }
      } else {
        if (!this.workplaceId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار مكان العمل"
          );
        }
      }

      this.lodding_bool = true;
      try {
        if (this.attendanceSearchMode === 1) {
          const {
            data
          } = await this.$axios.get(
            "/api/attendance/EmployeeAttendanceStatus",
            { params: { employeeId: this.EmployeeIdTimesheet } }
          );

          console.warn("data", data.data.data);
          this.attendanceEmployeeName = data.data.employeeName;
          this.attendanceStatusData = data.data.data || [];
        } else {
          const { data } = await this.$axios.get(
            "/api/attendance/workPlaceAttendance",
            {
              params: { workplaceId: this.workplaceId }
            }
          );
          this.attendanceWorkPlaceName = data.data.workPlace;
          this.attendanceStatusData = data.data.data || [];
        }
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        const message = error.response?.data?.message || "حدث خطأ في البحث";
        return this.notifyVue("top", "center", "danger", message);
      }
    },

    async exportAttendanceStatus(type) {
      if (this.attendanceSearchMode === 1) {
        if (!this.EmployeeIdTimesheet) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف"
          );
        }
      } else {
        if (!this.workplaceId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار مكان العمل"
          );
        }
      }

      this.lodding_bool = true;
      try {
        const isExcel = type === "excel";
        const url =
          this.attendanceSearchMode === 1
            ? "/api/attendance/EmployeeAttendanceStatusFile"
            : "/api/attendance/workPlaceAttendanceFile";

        const params =
          this.attendanceSearchMode === 1
            ? { employeeId: this.EmployeeIdTimesheet }
            : { workplaceId: this.workplaceId };

        const defaultFileName =
          this.attendanceSearchMode === 1
            ? "حالة حضور الموظف"
            : "حالة الحضور حسب المكان";

        const { data } = await this.$axios.get(url, {
          params,
          responseType: "blob"
        });

        const mimeType = isExcel
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "application/pdf";

        const ext = isExcel ? "xlsx" : "pdf";
        const blob = new Blob([data], { type: mimeType });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", `${defaultFileName}.${ext}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.lodding_bool = false;
      } catch (error) {
        this.lodding_bool = false;
        let message = "حدث خطأ في تنزيل التقرير";
        try {
          if (error.response && error.response.data) {
            const data = error.response.data;
            if (data.message) {
              message = data.message;
            }
          }
        } catch (_) {}
        return this.notifyVue("top", "center", "danger", message);
      }
    },

    downloadFileBlob(blob, name = "file") {
      const href = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement("a"), {
        href,
        style: "display:none",
        download: `${name}.pdf`
      });
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(href);
      a.remove();
    },

    // async downloadWord() {
    //   let T = localStorage.getItem("Nannotoken");
    //   let token = atob(T);
    //   let result = await axios.get(
    //     `${env.HR()}/api/hr/employeesReport/GetMonthlySummaryFile`,
    //     {
    //       headers: { Authorization: "Bearer " + token },

    //       params: {
    //         FromMonthDate: this.convert(this.DateFrom),
    //         ToMonthDate: this.convert(this.DateTo),
    //         // MonthDate: this.convert(this.monthDate_R),
    //         DepartmentClassificationsId: this.DepartmentClassificationsId,
    //       },
    //       responseType: "blob",
    //     }
    //   );
    //   const url = window.URL.createObjectURL(new Blob([result.data]));
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", "الحصيلة الشهرية.doc");
    //   document.body.appendChild(link);
    //   link.click();
    // },

    async downloadWord() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let result = await axios.get(
        `${env.HR()}/api/hr/employeesReport/GetMonthlySummaryWord`,
        {
          headers: { Authorization: "Bearer " + token },

          params: {
            FromMonthDate: this.convert(this.DateFrom),
            ToMonthDate: this.convert(this.DateTo),
            // MonthDate: this.convert(this.monthDate_R),
            DepartmentClassificationsId: this.DepartmentClassificationsId
          },
          responseType: "blob"
        }
      );
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "الحصيلة الشهرية.docx");
      document.body.appendChild(link);
      link.click();
    },

    async pdfSearch() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let dep;
      if (this.SectionId == "") {
        dep = this.DepartmentId;
      } else {
        dep = this.SectionId;
      }
      let result = await axios.get(
        `${env.HR()}/api/hr/employees/filter?FullName=${
          this.FullName_report
        }&JobtitelClassification=${this.JobtitelClassification}&JobTitleID=${
          this.JobTitleID_load
        }&NationalNumber=${this.NationalNumber}
         &DepartmentClassificationsId=${
           this.DepartmentClassificationsId
         }&DepartmentId=${this.DepartmentId}&SectionId=${
          this.SectionId
        }&JobType=${this.JobType}&ScientificDegreeId=${
          this.ScientificDegreeId
        }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
          this.StartingDateTo
        }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
          this.BonusDueDateFilterType
        }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
          this.MustRetireSoon
        }&PageSize=500
        `,
        {
          headers: { Authorization: "Bearer " + token }
        }
      );

      result.data.data.results.forEach((x, i) => {
        x.num = i + 1;
      });
      this.pdfData = result.data.data.results;
      this.countE = this.pdfData.length / 19;
    },
    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },
    async Search(filterData) {
      if (this.CurrentReport == 2) {
        try {
          this.total_Head_Count = 0;
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetStaffNumbersByDepartment`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.socialSolidarities = result.data.data.items;
          this.n_date = new Date();

          for (let i = 0; i < result.data.data.items.length; i++) {
            this.total_Head_Count =
              this.total_Head_Count + result.data.data.items[i].headCount;
          }
        } catch (error) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "الرجاء اعادة تسجيل الدخول"
          );
        }
      } else if (this.CurrentReport == 1) {
        this.pdfSearch();
      } else if (this.CurrentReport == 3) {
        try {
          if (!this.FullName_report) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال الموظف"
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeeCard?employeeId=${
              this.FullName_report
            }`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.socialSolidarities = result.data.data.items;
          this.fullName = result.data.data.fullName;
          this.shortName = result.data.data.shortName;
          // this.personalPicture = result.data.data.items.personalPicture;
          // this.pathLogo = result.data.data.items.personalPicture;
        } catch (error) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "الرجاء اعادة تسجيل الدخول"
          );
        }
      } else if (this.CurrentReport == 4) {
        try {
          // if (!this.Days_R) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء ادخال رصيد الايام"
          //   );
          // }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetHolidayBalancesEmployee?Days=${
              this.Days_R
            }&DepartmentId=${this.DepartmentId}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.socialSolidarities = result.data.data.items;
          this.fullName = result.data.data.fullName;
          this.shortName = result.data.data.shortName;
          this.countEmployee = result.data.data.items[0].countEmployee;
          // allData.length ? allData[0].countEmployee : ""
        } catch (error) {
          // return this.notifyVue(
          //   "top",
          //   "center",
          //   "danger",
          //   "الرجاء اعادة تسجيل الدخول"
          // );
        }
      } else if (this.CurrentReport == "5") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetVacationsInYear?EmployeeId=${
              this.EmployeeIdTimesheet
            }&VacationTypeId=${this.vacationId}&Year=${
              this.vacationYear
            }&DepartmentId=${this.DepartmentIdTimesheet}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = result.data.data;
          this.items = result.data.data.items;

          for (let i = 0; i < this.vacationTypes.length; i++) {
            if (this.vacationTypes[i].key == this.vacationId) {
              this.vacationName = this.vacationTypes[i].value;
            }
          }
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == 6) {
        try {
          if (!this.monthDate_R) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال تاريخ الشهر"
            );
          }
          if (!this.Grade) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال الدرجة"
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetCareerPromotion?MonthDate=${this.convert(
              this.monthDate_R
            )}&Grade=${this.Grade}&AboveGrade=${this.AboveGrade}`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.socialSolidarities = result.data.data.items;
          this.fullName = result.data.data.fullName;
          this.shortName = result.data.data.shortName;
        } catch (error) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "الرجاء اعادة تسجيل الدخول"
          );
        }
      } else if (this.CurrentReport == 7) {
        try {
          // تعليق بطلب من ياسر فى يوم 18/8/2025
          // if (!this.monthDate_R) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء ادخال تاريخ الشهر"
          //   );
          // }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetAnnualBonus?MonthDate=${this.convert(
              this.monthDate_R
            )}`,
            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.staffReportData = [];

          for (let i = 0; i < result.data.data.items.length; i++) {
            let schema = {
              id: i + 1,
              profileNumber: result.data.data.items[i].profileNumber,
              employeeName: result.data.data.items[i].employeeName,
              jobType: result.data.data.items[i].jobType,
              jobDate: result.data.data.items[i].jobDate,
              scientificDegree: result.data.data.items[i].scientificDegree,
              specialization: result.data.data.items[i].specialization,
              currentBonus: result.data.data.items[i].currentBonus,
              currentGrade: result.data.data.items[i].currentGrade,
              lastBonusUpdate: result.data.data.items[i].lastBonusUpdate,
              dueBonus: result.data.data.items[i].dueBonus,
              monthName: result.data.data.items[i].monthName,
              jobNumber: result.data.data.items[i].jobNumber
            };

            this.staffReportData.push(schema);
            this.id_all = this.staffReportData.length;
          }
          this.name = result.data.data;
        } catch (error) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "الرجاء اعادة تسجيل الدخول"
          );
        }
      } else if (this.CurrentReport == 8) {
        try {
          // if (!this.monthDate_R) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء ادخال تاريخ الشهر"
          //   );
          // }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetMonthlySummary`,
            {
              headers: { Authorization: "Bearer " + token },
              params: {
                FromMonthDate: this.convert(this.DateFrom),
                ToMonthDate: this.convert(this.DateTo),
                DepartmentClassificationsId: this.DepartmentClassificationsId
              }
            }
          );

          this.monthlyVariables = result.data.data.items;

          // console.warn("monthlyVariables", this.monthlyVariables);

          // this.name = result.data.data;
        } catch (error) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "الرجاء اعادة تسجيل الدخول"
          );
        }
      } else if (this.CurrentReport == "9") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          if (!this.EmployeeIdTimesheet) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء اختيار الموظف "
            );
          }

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;
          let date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + "1";

          const params = {
            fromDate: this.convert(this.DateFrom),
            toDate: this.convert(this.DateTo)
          };

          if (this.endedServiceEmployeeId) {
            params.EmployeeId = this.endedServiceEmployeeId
              ? this.endedServiceEmployeeId
              : null;
          }

          let result = await axios.get(
            `${env.HR()}/api/timesheet-self-service/Report`,
            {
              params,
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "21") {
        var filters = [];
        this.arabicName = [];
        this.enName = [];

        this.arabicName.push("اسم الموظف");
        this.enName.push("FullName");
        for (var i = 0; i < this.filter.length; i++) {
          this.arabicName.push(this.filter[i].arabicName);
        }

        for (var i = 0; i < this.filter.length; i++) {
          filters.push(this.filter[i].enName);
          this.enName.push(this.filter[i].enName);
        }

        if (filters.length > 14) {
          this.lodding_bool = false;
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، يجب تحديد 14 عمود على الاكثر "
          );
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        const queryString = JSON.stringify(this.filter);

        let schema = {
          Id: !this.EmployeeIdTimesheet ? null : this.EmployeeIdTimesheet,
          DepartmentId: this.DepartmentId == null ? null : this.DepartmentId,
          SectionId: this.SectionId == "" ? null : this.SectionId,
          JobtitelClassification:
            this.JobtitelClassification == ""
              ? null
              : this.JobtitelClassification,
          JobTitleID_load:
            this.JobTitleID_load == "" ? null : this.JobTitleID_load,
          DepartmentClassificationsId:
            this.DepartmentClassificationsId == ""
              ? null
              : this.DepartmentClassificationsId,
          JobType: this.JobType == "" ? null : parseInt(this.JobType),
          JobDescription:
            this.JobDescription == "" ? null : this.JobDescription,
          TypeOfEndService:
            this.TypeOfEndService == "" ? null : this.TypeOfEndService,
          IsEndedService:
            this.IsEndedService == "" ? null : this.IsEndedService,
          bankId: null,
          OrderByJobNumber: this.OrderByJobNumber == "" ? null : true,
          bankBranchId: null,
          JobTitleID: null,
          fullName: null,
          NationalNumber: null,
          jobNumber: null,
          nationalityId: null,
          ScientificDegreeId: null,
          profileNumber: null,
          jobDate: null,
          columns: filters,
          filters: filterData
        };

        // DepartmentClassificationsId

        let result = await axios.put(
          `${env.HR()}/api/hr/employeesReport/GetEmployeesAlllnfo`,
          schema,

          {
            headers: { Authorization: "Bearer " + token }
          }
        );

        this.items = result.data.data.items;

        // const url = `https://nanosoft.live/hr-reports/api/EmployeesReports/GetEmployeesAlllnfoPdf`

        // const response = await fetch(url, {
        //   method: 'put',
        //   url: '/account/register/',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify(schema)

        // });
        // this.lodding_bool = false;
        // const blob = await response.blob();

        // downloadFile(blob);
      } else if (this.CurrentReport == "10") {
        try {
          this.EmployeeIdTimesheet = null;
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          if (!this.dateF) {
            return this.notifyVue(
              "top",
              "center",
              "warning",
              "عفواً، الرجاء اختيار  تاريخ الطباعة "
            );
          }

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;

          let schema = {
            Year: Year,
            Month: Month,
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId: this.EmployeeIdTimesheet,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/Report `,
            schema,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "11") {
        if (!this.DateFrom || !this.DateTo) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار التاريخ  "
          );
        }

        this.lodding_bool = true;
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let schema = {
            FromDate: this.convert(this.DateFrom),
            ToDate: this.convert(this.DateTo),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds,
            IsWeekendDaysIncluded: this.IsWeekendDaysIncluded
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/TimeReport`,
            schema,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.allData = "";
          this.items = [];

          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        } finally {
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "12") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          if (!this.dateF) {
            return this.notifyVue(
              "top",
              "center",
              "warning",
              "عفواً، الرجاء اختيار  تاريخ الطباعة "
            );
          }

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;

          if (this.FromTime != null) {
            this.FromTime = this.FromTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.FromTime = null;
          }

          if (this.ToTime != null) {
            this.ToTime = this.ToTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.ToTime = null;
          }

          let schema = {
            Year: Year,
            date: moment(this.dateF).format("YYYY-MM-DD"),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
            WorkPlaceId: this.workplaceId ? this.workplaceId : null,
            FromTime: this.FromTime,
            ToTime: this.ToTime,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          if (this.EmployeeIdTimesheet) {
            schema.EmployeeId = this.EmployeeIdTimesheet
              ? this.EmployeeIdTimesheet
              : null;
          }

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/DailyReport`,
            schema,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );

          this.allData = "";
          this.items = [];

          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "13") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          // if (!this.dateF) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء اختيار  تاريخ الطباعة "
          //   );
          // }

          // let schema = {
          //   Year: this.Year,
          //   DepartmentId: this.DepartmentIdTimesheet,
          // };

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetRetirees?Year=${
              this.vacationYear
            }&DepartmentId=${this.DepartmentId}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "17") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeesJobInfo?Id=${
              this.EmployeeIdTimesheet
            }&JobtitelClassification=${
              this.JobtitelClassification
            }&JobTitleID=${this.JobTitleID_load}&NationalNumber=${
              this.NationalNumber
            }
         &DepartmentClassificationsId=${
           this.DepartmentClassificationsId
         }&DepartmentId=${this.DepartmentId}&SectionId=${
              this.SectionId
            }&JobType=${this.JobType}&ScientificDegreeId=${
              this.ScientificDegreeId
            }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
              this.StartingDateTo
            }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
              this.BonusDueDateFilterType
            }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
              this.MustRetireSoon
            }&PageSize=500
        `,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "21") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeesAlllnfo
        `,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "18") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          // if (!this.dateF) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء اختيار  تاريخ الطباعة "
          //   );
          // }

          // let schema = {
          //   Year: this.Year,
          //   DepartmentId: this.DepartmentIdTimesheet,
          // };

          // let IdN;
          // let DepartmentIdN;
          // if (this.DepartmentId == null) {
          //   DepartmentIdN = "";
          // }
          // else {
          //   DepartmentIdN = this.DepartmentId;
          // }

          // if (this.EmployeeIdTimesheet == null) {
          //   IdN = "";
          // }
          // else {
          //   IdN = this.EmployeeIdTimesheet;
          // }

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeesPersonalInfo?Id=${
              this.EmployeeIdTimesheet
            }&JobtitelClassification=${
              this.JobtitelClassification
            }&JobTitleID=${this.JobTitleID_load}&NationalNumber=${
              this.NationalNumber
            }
         &DepartmentClassificationsId=${
           this.DepartmentClassificationsId
         }&DepartmentId=${this.DepartmentId}&SectionId=${
              this.SectionId
            }&JobType=${this.JobType}&ScientificDegreeId=${
              this.ScientificDegreeId
            }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
              this.StartingDateTo
            }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
              this.BonusDueDateFilterType
            }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
              this.MustRetireSoon
            }&PageSize=500
        `,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "19") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          // if (!this.dateF) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء اختيار  تاريخ الطباعة "
          //   );
          // }

          // let schema = {
          //   Year: this.Year,
          //   DepartmentId: this.DepartmentIdTimesheet,
          // };

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeePromotions?EmployeeId=${
              this.EmployeeIdTimesheet
            }`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;

          this.EmployeeName = this.allData.employeeName;
          this.JobNumber = this.allData.jobNumber;
          this.Department = this.allData.department;
          this.CurrentGrade = this.allData.currentGrade;
          this.CurrentGradeDate = this.convert(this.allData.currentGradeDate);
          this.CurrentGradeDecisionNumber = this.allData.currentGradeDecisionNumber;
          this.CurrentGradeDecisionSource = this.allData.currentGradeDecisionSource;
          this.GradeAppointment = this.allData.gradeAppointment;
          this.GradeAppointmentDate = this.convert(
            this.allData.gradeAppointmentDate
          );
          this.GradeAppointmentDecisionNumber = this.allData.gradeAppointmentDecisionNumber;
          this.GradeAppointmentDecisionSource = this.allData.gradeAppointmentDecisionSource;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "20") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetWorkFreeEmployees?EmployeeId=${
              this.EmployeeIdTimesheet
            }&DepartmentId=${this.DepartmentIdTimesheet} `,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.items = result.data.data.items;
          this.allData = result.data.data;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "22") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/end-services/EndService?EmployeeId=${
              this.endEmployeesId
            }&JobNumber=${this.JobNumber}&type=${
              this.typeEndService
            }&From=${this.convert(this.DateFrom)}&To=${this.convert(
              this.DateTo
            )}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.items = result.data.data.results;
          this.allData = result.data.data;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "23") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/employee-efficiencies/filter?EmployeeId=${
              this.EmployeeIdTimesheet
            }&Year=${this.vacationYear}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.items = result.data.data;
          this.allData = result.data.data;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "14") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          // if (!this.dateF) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء اختيار  تاريخ الطباعة "
          //   );
          // }

          // let schema = {
          //   Year: this.Year,
          //   DepartmentId: this.DepartmentIdTimesheet,
          // };

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetNonPaidVacation?DepartmentId=${
              this.DepartmentId
            }&LetterNumber=${this.LetterNumber}&Reason=${this.Reason}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "15") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          // if (!this.dateF) {
          //   return this.notifyVue(
          //     "top",
          //     "center",
          //     "danger",
          //     "عفواً، الرجاء اختيار  تاريخ الطباعة "
          //   );
          // }

          // let schema = {
          //   Year: this.Year,
          //   DepartmentId: this.DepartmentIdTimesheet,
          // };

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetDelegatedEmployees?DepartmentId=${
              this.DepartmentId
            }&DelegationState=${this.DelegationState}`,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      } else if (this.CurrentReport == "16") {
        try {
          this.tableData = [];
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          if (!this.DateFrom) {
            this.lodding_bool = false;
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال التاربخ من"
            );
          }

          if (!this.DateTo) {
            this.lodding_bool = false;
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء ادخال التاربخ إلى"
            );
          }

          if (!this.TypeT) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، الرجاء اختيار النوع "
            );
          }

          let schema = {
            EmployeeId: this.EmployeeIdTimesheet,
            From:
              this.DateFrom == null
                ? null
                : moment(this.DateFrom).format("YYYY-MM-DD[T]hh:mm:ss"),
            To:
              this.DateTo == null
                ? null
                : moment(this.DateTo).format("YYYY-MM-DD[T]hh:mm:ss"),
            Type: parseInt(this.TypeT),
            DepartmentId: this.DepartmentIdTimesheet,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/DelayCheckinandEarlyCheckoutReport`,
            schema,

            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          this.allData = "";
          this.items = "";
          this.allData = result.data.data;
          this.items = result.data.data.items;
        } catch (error) {
          this.message(error);
        }
      }
    },

    empty() {
      this.EmployeeIdTimesheet = null;
      this.DepartmentId = null;
      this.JobTitleID_load = null;
      this.JobtitelClassification = null;
      this.SectionId = null;
      this.DepartmentClassificationsId = null;
      this.JobType = null;
      this.JobDescription = null;
      this.filter = [];
      this.ReportAddress = null;
      this.IsEndedService = false;
      this.TypeOfEndService = null;
    },

    downloadFile(url) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob"; // Set the response type to blob

      // Track progress
      xhr.addEventListener("progress", function(event) {
        if (event.lengthComputable) {
          var percentComplete = (event.loaded / event.total) * 100;
          console.log("Download progress: " + percentComplete.toFixed(2) + "%");
        } else {
          console.log("Unable to compute progress information.");
        }
      });

      // Triggered when the file is ready to download
      xhr.onload = function(event) {
        if (xhr.status === 200) {
          // Create a temporary link element
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(xhr.response);
          link.download = "filename"; // Set the desired file name
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      };

      xhr.send();
    },

    async test() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (this.monthDate == null) {
          this.monthDate = "";
        } else {
          this.monthDate = this.convert(this.monthDate);
        }
        let result = await axios.get(
          `${env.HR()}/api/SalariesReports/SalariesChequePerBankBranchReport?MonthDate=${
            this.monthDate
          }&BankId=${this.selectBank}&BankBranchId=${this.selectBankBranch}`,

          {
            headers: { Authorization: "Bearer " + token }
          }
        );

        var divContents = result.data.data;
      } catch (error) {
        this.message(error);
      }

      // var printWindow = window.open(' ', '__new', 'height=400,width=800');

      var printWindow = window.open(" ", "", "height=400,width=800");

      printWindow.document.write("</head><body>");
      printWindow.document.write();
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
      // }

      // if (this.st == "5") {

      // }
      // if (this.st != "14") {
      //     this.$refs.html2Pdf.generatePdf();
      // }
    },

    clear_DepartmentClassificationsId() {
      this.DepartmentClassificationsId = "";
    },

    clear_SectionId() {
      this.SectionId = "";
    },

    clear_DepartmentId() {
      this.DepartmentId = null;
    },

    async progressPdf(event) {
      console.warn("progressPdf :::: ", event);
      // event == 70 ? setTimeout(() => (this.currentStep = 1), 3000) : "";
      // event == 100 ? (this.currentStep = 2) : "";
      // event == 100
      //   ? setTimeout(() => (this.pdfLoadingActive = false), 600)
      //   : "";
      // event == 100 ? setTimeout(() => (this.currentStep = 0), 650) : "";
    },

    async startPagination() {},

    async hasPaginated(event) {
      console.warn("hasPaginated ::::", event);
      this.currentStep = 2;
    },

    async generateReport_ex() {
      this.lodding_bool = true;

      if (this.CurrentReport == "19") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeePromotionsPdf?EmployeeId=${
              this.EmployeeIdTimesheet
            }&ReportType=Excel`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير تسلسل حركة ترقيات الموظف.xlsx";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "12") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;

          if (!this.dateF) {
            this.lodding_bool = false;

            return this.notifyVue(
              "top",
              "center",
              "warning",
              "عفواً، الرجاء اختيار  تاريخ الطباعة "
            );
          }

          if (this.FromTime != null) {
            this.FromTime = this.FromTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.FromTime = null;
          }

          if (this.ToTime != null) {
            this.ToTime = this.ToTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.ToTime = null;
          }

          let schema = {
            ReportType: "Excel",
            Year: Year,
            date: this.convert(this.dateF),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
            WorkPlaceId: this.workplaceId ? this.workplaceId : null,
            FromTime: this.FromTime,
            ToTime: this.ToTime,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/DailyReportFile`,
            schema,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الحضور والإنصراف اليومي.xlsx";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "17") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let IdN;
        let DepartmentIdN;
        if (this.DepartmentId == null) {
          DepartmentIdN = "";
        } else {
          DepartmentIdN = this.DepartmentId;
        }

        if (this.EmployeeIdTimesheet == null) {
          IdN = "";
        } else {
          IdN = this.EmployeeIdTimesheet;
        }

        await fetch(
          `https://nanosoft.live/hr-reports/api/EmployeesReports/GetEmployeesJobInfo?reportTypes=1&BaseUrl=${env.HR()}&token=${token}&Id=${IdN}&JobtitelClassification=${
            this.JobtitelClassification
          }&JobTitleID=${this.JobTitleID_load}&NationalNumber=${
            this.NationalNumber
          }
           &DepartmentClassificationsId=${
             this.DepartmentClassificationsId
           }&DepartmentId=${DepartmentIdN}&SectionId=${
            this.SectionId
          }&JobType=${this.JobType}&ScientificDegreeId=${
            this.ScientificDegreeId
          }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
            this.StartingDateTo
          }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
            this.BonusDueDateFilterType
          }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
            this.MustRetireSoon
          }
          &JobDescription=${this.JobDescription}&IsEndedService=${
            this.IsEndedService
          }&PageSize=500`
        )
          .then(response => {
            this.lodding_bool = false;
            return response.blob();
          })
          .then(blob => {
            downloadFile(blob);
          });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "البيانات الوظيفية.xlsx"
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } else if (this.CurrentReport == "21") {
        try {
          var filters = [];

          for (var i = 0; i < this.filter.length; i++) {
            filters.push(this.filter[i].enName);
          }

          if (filters.length > 14) {
            this.lodding_bool = false;
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، يجب تحديد 14 عمود على الاكثر "
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          const queryString = JSON.stringify(this.filter);

          let params = {
            ReportType: "Excel",

            Id:
              this.EmployeeIdTimesheet == null
                ? null
                : this.EmployeeIdTimesheet,

            DepartmentId: this.DepartmentId == null ? null : this.DepartmentId,
            SectionId: this.SectionId == "" ? null : this.SectionId,
            JobtitelClassification:
              this.JobtitelClassification == ""
                ? null
                : this.JobtitelClassification,
            JobTitleID_load:
              this.JobTitleID_load == "" ? null : this.JobTitleID_load,
            DepartmentClassificationsId:
              this.DepartmentClassificationsId == ""
                ? null
                : this.DepartmentClassificationsId,
            JobType: this.JobType == "" ? null : this.JobType,
            JobDescription:
              this.JobDescription == "" ? null : this.JobDescription,
            TypeOfEndService:
              this.TypeOfEndService == "" ? null : this.TypeOfEndService,
            IsEndedService:
              this.IsEndedService == "" ? null : this.IsEndedService,
            ReportAddress: this.ReportAddress == "" ? null : this.ReportAddress,
            bankId: null,
            bankBranchId: null,
            JobTitleID: null,
            fullName: null,
            NationalNumber: null,
            jobNumber: null,
            nationalityId: null,
            ScientificDegreeId: null,
            profileNumber: null,
            jobDate: null,

            filters: filters
          };

          const urlApi = `${env.HR()}/api/hr/EmployeesReport/GetEmployeesAlllnfoReport`;
          const response = await axios.put(urlApi, params, {
            headers: { Authorization: "Bearer " + token },
            responseType: "blob" // Important to handle binary data
          });

          // Create a new Blob object using the response data
          const blob = new Blob([response.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "التقرير الشامل للموظف.xlsx";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "18") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let IdN;
        let DepartmentIdN;
        if (this.DepartmentId == null) {
          DepartmentIdN = "";
        } else {
          DepartmentIdN = this.DepartmentId;
        }

        if (this.EmployeeIdTimesheet == null) {
          IdN = "";
        } else {
          IdN = this.EmployeeIdTimesheet;
        }

        await fetch(
          `https://nanosoft.live/hr-reports/api/EmployeesReports/GetEmployeesPersonalInfo?reportTypes=1&BaseUrl=${env.HR()}&token=${token}&Id=${IdN}&JobtitelClassification=${
            this.JobtitelClassification
          }&JobTitleID=${this.JobTitleID_load}&NationalNumber=${
            this.NationalNumber
          }
           &DepartmentClassificationsId=${
             this.DepartmentClassificationsId
           }&DepartmentId=${DepartmentIdN}&SectionId=${
            this.SectionId
          }&JobType=${this.JobType}&ScientificDegreeId=${
            this.ScientificDegreeId
          }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
            this.StartingDateTo
          }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
            this.BonusDueDateFilterType
          }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
            this.MustRetireSoon
          }&PageSize=500`
        )
          .then(response => {
            this.lodding_bool = false;
            return response.blob();
          })
          .then(blob => {
            downloadFile(blob);
          });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "البيانات الشخصية.xlsx"
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } else if (this.CurrentReport == "11") {
        try {
          if (!this.DateFrom || !this.DateTo) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً،الرجاء اختيار التاريخ"
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let schema = {
            FromDate: this.convert(this.DateFrom),
            ToDate: this.convert(this.DateTo),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds,
            ReportType: "Excel",
            IsWeekendDaysIncluded: this.IsWeekendDaysIncluded
          };

          const urlApi = `${env.HR()}/api/hr/Timesheet/TimeReportFile`;
          const response = await axios.patch(urlApi, schema, {
            headers: { Authorization: "Bearer " + token },
            responseType: "blob" // Important to handle binary data
          });

          // Create a new Blob object using the response data
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الحضور والانصراف التفصيلي.xlsx";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error downloading the Excel file", error);
        } finally {
          this.lodding_bool = false;
        }
      }
    },

    //-------- report viewer ---------

    async generateReport() {
      this.lodding_bool = true;

      if (this.CurrentReport == "19") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeePromotionsPdf?EmployeeId=${
              this.EmployeeIdTimesheet
            }&ReportType=Pdf`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير حركة ترقيات الموظف.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "10") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          if (!this.dateF) {
            this.lodding_bool = false;
            return this.notifyVue(
              "top",
              "center",
              "warning",
              "عفواً، الرجاء اختيار  تاريخ الطباعة "
            );
          }

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;

          let schema = {
            Year: Year,
            Month: Month,
            DepartmentId: this.DepartmentIdTimesheet,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/ReportPdf `,
            schema,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الحضور والإنصراف لوحدة تنظيمية.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "3") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetEmployeeCardReport?employeeId=${
              this.FullName_report
            }&ShowProfile=${this.personalPicture}`,
            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير بطاقة الموظف.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "1") {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        await fetch(
          `https://nanosoft.live/hr-reports/api/EmployeesReports/EmployeesList?reportTypes=0&BaseUrl=${env.HR()}&token=${token}&FullName=${
            this.FullName_report
          }&JobtitelClassification=${this.JobtitelClassification}&JobTitleID=${
            this.JobTitleID_load
          }&NationalNumber=${this.NationalNumber}
         &DepartmentClassificationsId=${
           this.DepartmentClassificationsId
         }&DepartmentId=${this.DepartmentId}&SectionId=${
            this.SectionId
          }&JobType=${parseInt(this.JobType)}&ScientificDegreeId=${
            this.ScientificDegreeId
          }&StartingDateFrom=${this.StartingDateFrom}&StartingDateTo=${
            this.StartingDateTo
          }&SortBy=${this.SortBy}&BonusDueDateFilterType=${
            this.BonusDueDateFilterType
          }&TypeOfEndService=${this.TypeOfEndService}&MustRetireSoon=${
            this.MustRetireSoon
          }&PageSize=500

        `
        )
          .then(response => {
            this.lodding_bool = false;
            return response.blob();
          })
          .then(blob => {
            downloadFile(blob);
          });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "تقرير قوائم الموظفين.pdf"
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        }
      } else if (this.CurrentReport == "2") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetStaffNumbersByDepartmentPdf `,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير بأعداد الموظفين حسب الادارة.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "4") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetHolidayBalancesEmployeePdf?Days=${
              this.Days_R
            }&DepartmentId=${this.DepartmentId}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير كشف برصيد الاجازات السنوية.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "6") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetCareerPromotionPdf?MonthDate=${this.convert(
              this.monthDate_R
            )}&Grade=${this.Grade}&AboveGrade=${this.AboveGrade}`,
            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير  الترقيات.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "7") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetAnnualBonusPdf?MonthDate=${this.convert(
              this.monthDate_R
            )}`,
            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير العلاوات السنوية.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "13") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetRetireesPdf?Year=${
              this.vacationYear
            }&DepartmentId=${this.DepartmentId}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير المحالين على التقاعد.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "15") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetDelegatedEmployeesPdf?DepartmentId=${
              this.DepartmentId
            }&DelegationState=${this.DelegationState}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير كشف المنتدبين.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "14") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetNonPaidVacationPdf?DepartmentId=${
              this.DepartmentId
            }&LetterNumber=${this.LetterNumber}&Reason=${this.Reason}`,
            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "كشف الإجازة بدون مرتب.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "5") {
        try {
          //   if (this.StartOn == null) {
          //     this.StartOn = "";
          //   } else {
          //     this.DepartmentIdTimesheet = this.convert(this.StartOn);
          //   }

          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetVacationsInYearPdf?EmployeeId=${
              this.EmployeeIdTimesheet
            }&VacationTypeId=${this.vacationId}&Year=${
              this.vacationYear
            }&DepartmentId=${this.DepartmentIdTimesheet}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الإجازات.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "20") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/GetWorkFreeEmployeesPdf?EmployeeId=${
              this.EmployeeIdTimesheet
            }&DepartmentId=${this.DepartmentIdTimesheet} `,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "كشف الموظفين المتفرغين.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "21") {
        try {
          var filters = [];

          for (var i = 0; i < this.filter.length; i++) {
            filters.push(this.filter[i].enName);
          }

          if (filters.length > 14) {
            this.lodding_bool = false;
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً، يجب تحديد 14 عمود على الاكثر "
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          const queryString = JSON.stringify(this.filter);

          let params = {
            ReportType: "PDF",

            Id:
              this.EmployeeIdTimesheet == null
                ? null
                : this.EmployeeIdTimesheet,

            DepartmentId: this.DepartmentId == null ? null : this.DepartmentId,
            SectionId: this.SectionId == "" ? null : this.SectionId,
            JobtitelClassification:
              this.JobtitelClassification == ""
                ? null
                : this.JobtitelClassification,
            JobTitleID_load:
              this.JobTitleID_load == "" ? null : this.JobTitleID_load,
            DepartmentClassificationsId:
              this.DepartmentClassificationsId == ""
                ? null
                : this.DepartmentClassificationsId,
            JobType: this.JobType == "" ? null : parseInt(this.JobType),
            JobDescription:
              this.JobDescription == "" ? null : this.JobDescription,
            TypeOfEndService:
              this.TypeOfEndService == "" ? null : this.TypeOfEndService,
            IsEndedService:
              this.IsEndedService == "" ? null : this.IsEndedService,
            ReportAddress: this.ReportAddress == "" ? null : this.ReportAddress,
            bankId: null,
            bankBranchId: null,
            JobTitleID: null,
            fullName: null,
            NationalNumber: null,
            jobNumber: null,
            nationalityId: null,
            ScientificDegreeId: null,
            profileNumber: null,
            jobDate: null,

            filters: filters
          };

          const urlApi = `${env.HR()}/api/hr/EmployeesReport/GetEmployeesAlllnfoReport`;
          const response = await axios.put(urlApi, params, {
            headers: { Authorization: "Bearer " + token },
            responseType: "blob" // Important to handle binary data
          });

          // Create a new Blob object using the response data
          const blob = new Blob([response.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "التقرير الشامل للموظف.PDF";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "22") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/end-services/EndServicePdf?EmployeeId=${
              this.endEmployeesId
            }&JobNumber=${this.JobNumber}&type=${
              this.typeEndService
            }&From=${this.convert(this.DateFrom)}&To=${this.convert(
              this.DateTo
            )}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير المنتهي خدمتهم.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "23") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/employeesReport/EmployeeEffeciency?EmployeeId=${
              this.EmployeeIdTimesheet
            }&Year=${this.vacationYear}`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الكفاءة السنوية.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "24") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let result = await axios.get(
            `${env.HR()}/api/hr/EmployeesReport/EmployeeStatment?EmployeeId=${
              this.EmployeeIdTimesheet
            }`,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );
          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = " تقرير الإفادة الإدارية.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "11") {
        try {
          if (!this.DateFrom || !this.DateTo) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              "عفواً،الرجاء اختيار التاريخ"
            );
          }
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let schema = {
            FromDate: this.convert(this.DateFrom),
            ToDate: this.convert(this.DateTo),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,

            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds,
            ReportType: "Pdf",
            IsWeekendDaysIncluded: this.IsWeekendDaysIncluded
          };

          const urlApi = `${env.HR()}/api/hr/Timesheet/TimeReportFile`;
          const response = await axios.patch(urlApi, schema, {
            headers: { Authorization: "Bearer " + token },
            responseType: "blob" // Important to handle binary data
          });

          // Create a new Blob object using the response data
          const blob = new Blob([response.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الحضور والإنصراف التفصيلي.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error downloading the PDF", error);
        } finally {
          this.lodding_bool = false;
        }
      } else if (this.CurrentReport == "12") {
        try {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);

          let d = new Date(this.dateF);
          let Year = d.getFullYear();
          let Month = d.getMonth() + 1;

          if (!this.dateF) {
            this.lodding_bool = false;

            return this.notifyVue(
              "top",
              "center",
              "warning",
              "عفواً، الرجاء اختيار  تاريخ الطباعة "
            );
          }

          if (this.FromTime != null) {
            this.FromTime = this.FromTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.FromTime = null;
          }

          if (this.ToTime != null) {
            this.ToTime = this.ToTime.replace(/[AM-PM-ص-م]/gi, "");
          } else {
            this.ToTime = null;
          }

          let schema = {
            ReportType: "Pdf",
            Year: Year,
            date: this.convert(this.dateF),
            DepartmentId: this.DepartmentIdTimesheet,
            EmployeeId:
              this.EmployeeIdTimesheet == "" ? null : this.EmployeeIdTimesheet,
            WorkPlaceId: this.workplaceId ? this.workplaceId : null,
            FromTime: this.FromTime,
            ToTime: this.ToTime,
            FilterDeparmentClassificationsIds:
              this.FilterDeparmentClassificationsIds == ""
                ? null
                : this.FilterDeparmentClassificationsIds
          };

          let result = await axios.patch(
            `${env.HR()}/api/hr/Timesheet/DailyReportFile`,
            schema,

            {
              headers: { Authorization: "Bearer " + token },
              responseType: "blob"
            }
          );

          // Create a new Blob object using the response data
          const blob = new Blob([result.data], { type: "application/pdf" });

          // Create a link element
          const link = document.createElement("a");

          // Create a URL for the Blob and set it as the href attribute of the link
          const url = window.URL.createObjectURL(blob);
          link.href = url;

          // Set the download attribute with a filename
          link.download = "تقرير الحضور والإنصراف اليومي.pdf";

          // Append the link to the document body (it won't be visible)
          document.body.appendChild(link);

          // Programmatically click the link to trigger the download
          link.click();

          // Clean up by removing the link and revoking the object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.lodding_bool = false;
        } catch (error) {
          console.error("Error downloading the PDF", error);
          this.lodding_bool = false;
        }
      } else {
        setTimeout(() => {
          this.$refs.html2Pdf.generatePdf();
        }, 1000);
      }

      this.lodding_bool = false;
    },

    generateReport2() {
      this.lodding_bool = true;
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
      }, 1000);
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.warn("beforeDownload ::::");

      await html2pdf()
        .set(options)
        .set({ pagebreak: { avoid: "tr" } })
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then(pdf => {
          pdf.setFont("Amiri-Regular");
          // pdf.setR2L(true);
          pdf.setLanguage("ar-KW");
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(30);
            pdf.setTextColor(150);
            // pdf.text(
            //   this.companyName,
            //   pdf.internal.pageSize.getWidth() * 0.77,
            //   40,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   this.companyDesc,
            //   pdf.internal.pageSize.getWidth() * 0.63,
            //   55,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.1,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.5,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.9,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
          }
        })
        .save()
        .then(() => {
          this.lodding_bool = false;
          // this.pdfLoadingActive = false;
          // this.currentStep = 0;
        });
    },

    async hasDownloaded(event) {
      console.warn("hasDownloaded ::::", event);
    },

    convertN(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "";
        }
        return formattedDate;
      } catch (error) {}
    },

    convert(event) {
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    convert_rtl(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getMonth() + 1 + "-" + d.getFullYear();
      } catch (error) {}
    },

    convert_MonthToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getMonth() + 1 + "-" + d.getFullYear();
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },

    async getCompanyInfo() {
      this.companyName = this.globalCompanyInfo.fullName;
      this.companyDesc = this.globalCompanyInfo.shortName;
    },

    async getBankInfo() {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(`${env.HR()}/api/SalariesReports`, {
        headers: { Authorization: "Bearer " + token }
      });

      this.allBanks = res.data.data.banks;
    },

    async getBankBranches(key) {
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(`${env.HR()}/api/bank-branches/load/${key}`, {
        headers: { Authorization: "Bearer " + token }
      });

      this.allBankBranches = res.data.data;
    },

    // الكشف التحليلى لشهر
    async getGeneralAnalytical() {
      if (!this.monthDate) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/SalariesReports/GeneralAnalytical?MonthDate=${this.convert(
          this.monthDate
        )}`,
        {
          headers: { Authorization: "Bearer " + token }
        }
      );

      this.generalAnalytical = res.data.data;
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    }
  }
};
</script>

<style lang="scss">
.md-table.md-theme-default .md-table-row td {
  border-top-color: rgba(0, 0, 0, 0.12);
  border-top-color: var(
    --md-theme-default-divider-on-background,
    rgba(0, 0, 0, 0.12)
  );
  text-align: -webkit-center !important;
}

.md-table-head .md-table-head-label {
  padding-right: 0 !important;
}

.pdf-container header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.sub-head-time {
  margin-right: 20px;
  display: inline-block;
}

.overlay-pdf {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.head-loading-pdf {
  color: #4caf50;
  font-weight: bold;
}

.step-progress__wrapper-after {
  transform-origin: right center !important;
}

.reportFont {
  font-size: 17px;
  // font-weight: bold;
}

.rtl .md-table-head .md-table-head-label {
  font-size: 17px;
  font-weight: bold;
}

.md-table-head:last-child:not(:first-child) .md-table-head-label {
  padding-right: 24px !important;
}

.w-200 .md-table-cell-container p {
  width: 200px !important;
}

.report-fss {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }

  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }

  .table-header {
    display: table-header-group;
  }

  .fs-head {
    font-size: 27px !important;
  }

  .w-100 {
    width: 100% !important;
  }
}

.connection-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  min-width: 96px;
  justify-content: center;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Cairo", sans-serif;
  line-height: 1.6;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  .connection-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.45);
  }

  &.is-online {
    background: linear-gradient(135deg, #43a047, #2e7d32);
    color: #fff;
    border-color: #2e7d32;
  }

  &.is-offline {
    background: linear-gradient(135deg, #e53935, #c62828);
    color: #fff;
    border-color: #c62828;
  }

  &.is-synced {
    background: linear-gradient(135deg, #1e88e5, #1565c0);
    color: #fff;
    border-color: #1565c0;
  }

  &.is-not-synced {
    background: linear-gradient(135deg, #fb8c00, #ef6c00);
    color: #fff;
    border-color: #ef6c00;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
}
</style>
